// Sherwin-Williams color data for the cabinet visualizer.
// Full SW deck parsed from the official SW color card PDF. 1526 colors.
// On-screen hex is representative, not an exact paint match.
window.SW_COLORS = [
  { name: "Mulberry Silk", code: "SW 0001", hex: "#94766C" },
  { name: "Chelsea Mauve", code: "SW 0002", hex: "#BEAC9F" },
  { name: "Cabbage Rose", code: "SW 0003", hex: "#C59F91" },
  { name: "Rose Brocade", code: "SW 0004", hex: "#996C6E" },
  { name: "Deepest Mauve", code: "SW 0005", hex: "#6D595A" },
  { name: "Toile Red", code: "SW 0006", hex: "#8B534E" },
  { name: "Decorous Amber", code: "SW 0007", hex: "#AC7559" },
  { name: "Cajun Red", code: "SW 0008", hex: "#8D422F" },
  { name: "Eastlake Gold", code: "SW 0009", hex: "#C28E61" },
  { name: "Wickerwork", code: "SW 0010", hex: "#C19E80" },
  { name: "Crewel Tan", code: "SW 0011", hex: "#CBB99B" },
  { name: "Empire Gold", code: "SW 0012", hex: "#C19F6E" },
  { name: "Majolica Green", code: "SW 0013", hex: "#AEB08F" },
  { name: "Sheraton Sage", code: "SW 0014", hex: "#8F8666" },
  { name: "Gallery Green", code: "SW 0015", hex: "#708672" },
  { name: "Billiard Green", code: "SW 0016", hex: "#45584D" },
  { name: "Calico", code: "SW 0017", hex: "#8CA49C" },
  { name: "Teal Stencil", code: "SW 0018", hex: "#627F7B" },
  { name: "Festoon Aqua", code: "SW 0019", hex: "#A0BBB8" },
  { name: "Peacock Plume", code: "SW 0020", hex: "#739694" },
  { name: "Queen Anne Lilac", code: "SW 0021", hex: "#C0B6B4" },
  { name: "Patchwork Plum", code: "SW 0022", hex: "#7E696A" },
  { name: "Pewter Tankard", code: "SW 0023", hex: "#A39B90" },
  { name: "Curio Gray", code: "SW 0024", hex: "#988977" },
  { name: "Rosedust", code: "SW 0025", hex: "#CC8D84" },
  { name: "Rachel Pink", code: "SW 0026", hex: "#E8B9AE" },
  { name: "Aristocrat Peach", code: "SW 0027", hex: "#ECCEB9" },
  { name: "Caen Stone", code: "SW 0028", hex: "#ECD0B1" },
  { name: "Acanthus", code: "SW 0029", hex: "#CDCDB4" },
  { name: "Colonial Yellow", code: "SW 0030", hex: "#EFC488" },
  { name: "Dutch Tile Blue", code: "SW 0031", hex: "#9AABAB" },
  { name: "Needlepoint Navy", code: "SW 0032", hex: "#546670" },
  { name: "Rembrandt Ruby", code: "SW 0033", hex: "#974F49" },
  { name: "Roycroft Rose", code: "SW 0034", hex: "#C08F80" },
  { name: "Warm Beige", code: "SW 0035", hex: "#EEDAC3" },
  { name: "Buckram Binding", code: "SW 0036", hex: "#D9C3A6" },
  { name: "Morris Room Grey", code: "SW 0037", hex: "#ADA193" },
  { name: "Library Pewter", code: "SW 0038", hex: "#7F7263" },
  { name: "Mellow Mauve", code: "SW 0039", hex: "#C4957A" },
  { name: "Roycroft Adobe", code: "SW 0040", hex: "#A76251" },
  { name: "Dard Hunter Green", code: "SW 0041", hex: "#3A4A3F" },
  { name: "Ruskin Room Green", code: "SW 0042", hex: "#ACA17D" },
  { name: "Peristyle Brass", code: "SW 0043", hex: "#AE905E" },
  { name: "Hubbard Squash", code: "SW 0044", hex: "#E9BF8C" },
  { name: "Antiquarian Brown", code: "SW 0045", hex: "#946644" },
  { name: "White Hyacinth", code: "SW 0046", hex: "#F3E5D1" },
  { name: "Studio Blue Green", code: "SW 0047", hex: "#6D817B" },
  { name: "Bunglehouse Blue", code: "SW 0048", hex: "#47626F" },
  { name: "Silver Gray", code: "SW 0049", hex: "#B8B2A2" },
  { name: "Classic Light Buff", code: "SW 0050", hex: "#F0EADC" },
  { name: "Classic Ivory", code: "SW 0051", hex: "#F2E0C3" },
  { name: "Pearl Gray", code: "SW 0052", hex: "#CBCEC5" },
  { name: "Porcelain", code: "SW 0053", hex: "#E9E0D5" },
  { name: "Twilight Gray", code: "SW 0054", hex: "#C8BFB5" },
  { name: "Light French Gray", code: "SW 0055", hex: "#C2C0BB" },
  { name: "Classic Sand", code: "SW 0056", hex: "#D6BCAA" },
  { name: "Chinese Red", code: "SW 0057", hex: "#9E3E33" },
  { name: "Jazz Age Coral", code: "SW 0058", hex: "#F1BFB1" },
  { name: "Frostwork", code: "SW 0059", hex: "#CBD0C2" },
  { name: "Alexandrite", code: "SW 0060", hex: "#598C74" },
  { name: "Salon Rose", code: "SW 0061", hex: "#AB7878" },
  { name: "Studio Mauve", code: "SW 0062", hex: "#C6B9B8" },
  { name: "Blue Sky", code: "SW 0063", hex: "#ABD1C9" },
  { name: "Blue Peacock", code: "SW 0064", hex: "#014E4C" },
  { name: "Vogue Green", code: "SW 0065", hex: "#4B5645" },
  { name: "Cascade Green", code: "SW 0066", hex: "#ACB19F" },
  { name: "Belvedere Cream", code: "SW 0067", hex: "#F0CDA0" },
  { name: "Copen Blue", code: "SW 0068", hex: "#C2CCC4" },
  { name: "Rose Tan", code: "SW 0069", hex: "#CD9C85" },
  { name: "Pink Shadow", code: "SW 0070", hex: "#DEC3B9" },
  { name: "Orchid", code: "SW 0071", hex: "#BC9C9E" },
  { name: "Deep Maroon", code: "SW 0072", hex: "#623F45" },
  { name: "Chartreuse", code: "SW 0073", hex: "#E1D286" },
  { name: "Radiant Lilac", code: "SW 0074", hex: "#A489A0" },
  { name: "Holiday Turquoise", code: "SW 0075", hex: "#8AC6BD" },
  { name: "Appleblossom", code: "SW 0076", hex: "#DAB5B4" },
  { name: "Classic French Gray", code: "SW 0077", hex: "#888782" },
  { name: "Sunbeam Yellow", code: "SW 0078", hex: "#F0D39D" },
  { name: "Pinky Beige", code: "SW 0079", hex: "#C9AA98" },
  { name: "Pink Flamingo", code: "SW 0080", hex: "#CD717B" },
  { name: "Skyline Steel", code: "SW 1015", hex: "#C6BFB3" },
  { name: "Venetian Yellow", code: "SW 1666", hex: "#F6E3A1" },
  { name: "Icy Lemonade", code: "SW 1667", hex: "#F4E8B2" },
  { name: "Pineapple Cream", code: "SW 1668", hex: "#F2EAC3" },
  { name: "Merlot", code: "SW 2704", hex: "#51323B" },
  { name: "Rockweed", code: "SW 2735", hex: "#443735" },
  { name: "Charcoal Blue", code: "SW 2739", hex: "#3D4450" },
  { name: "Mineral Gray", code: "SW 2740", hex: "#515763" },
  { name: "Rookwood Dark Red", code: "SW 2801", hex: "#4B2929" },
  { name: "Rookwood Red", code: "SW 2802", hex: "#622F2D" },
  { name: "Rookwood Terra Cotta N/A", code: "SW 2803", hex: "#975840" },
  { name: "Renwick Rose Beige", code: "SW 2804", hex: "#AF8871" },
  { name: "Renwick Beige", code: "SW 2805", hex: "#C3B09D" },
  { name: "Rookwood Brown", code: "SW 2806", hex: "#7F614A" },
  { name: "Rookwood Medium", code: "SW 2807", hex: "#6E5241" },
  { name: "Rookwood Dark Brown N/A", code: "SW 2808", hex: "#5F4D43" },
  { name: "Rookwood Shutter", code: "SW 2809", hex: "#303B39" },
  { name: "Rookwood Sash Green N/A", code: "SW 2810", hex: "#506A67" },
  { name: "Rookwood Blue Green", code: "SW 2811", hex: "#738478" },
  { name: "Rookwood Jade", code: "SW 2812", hex: "#979F7F" },
  { name: "Downing Straw", code: "SW 2813", hex: "#CAAB7D" },
  { name: "Rookwood Antique", code: "SW 2814", hex: "#A58258" },
  { name: "Renwick Olive", code: "SW 2815", hex: "#97896A" },
  { name: "Rookwood Dark Green N/A", code: "SW 2816", hex: "#565C4A" },
  { name: "Rookwood Amber", code: "SW 2817", hex: "#C08650" },
  { name: "Renwick Heather", code: "SW 2818", hex: "#8B7D7B" },
  { name: "Downing Slate", code: "SW 2819", hex: "#777F86" },
  { name: "Downing Earth", code: "SW 2820", hex: "#887B67" },
  { name: "Downing Stone", code: "SW 2821", hex: "#A6A397" },
  { name: "Downing Sand", code: "SW 2822", hex: "#CBBCA5" },
  { name: "Rookwood Clay", code: "SW 2823", hex: "#9A7E64" },
  { name: "Renwick Golden Oak", code: "SW 2824", hex: "#96724C" },
  { name: "Colonial Revival Green", code: "SW 2826", hex: "#A39B7E" },
  { name: "Colonial Revival Stone", code: "SW 2827", hex: "#A7947C" },
  { name: "Colonial Revival Tan", code: "SW 2828", hex: "#D3B699" },
  { name: "Classical White", code: "SW 2829", hex: "#ECE1CB" },
  { name: "Classical Gold", code: "SW 2831", hex: "#EBB875" },
  { name: "Colonial Revival Gray", code: "SW 2832", hex: "#B4B9B9" },
  { name: "Roycroft Vellum", code: "SW 2833", hex: "#E8D9BD" },
  { name: "Birdseye Maple", code: "SW 2834", hex: "#E4C495" },
  { name: "Craftsman Brown", code: "SW 2835", hex: "#AE9278" },
  { name: "Quartersawn Oak", code: "SW 2836", hex: "#85695B" },
  { name: "Aurora Brown", code: "SW 2837", hex: "#6A4238" },
  { name: "Polished Mahogany", code: "SW 2838", hex: "#432722" },
  { name: "Roycroft Copper Red", code: "SW 2839", hex: "#7B3728" },
  { name: "Hammered Silver", code: "SW 2840", hex: "#978A7F" },
  { name: "Weathered Shingle", code: "SW 2841", hex: "#937F68" },
  { name: "Roycroft Suede", code: "SW 2842", hex: "#A79473" },
  { name: "Roycroft Brass", code: "SW 2843", hex: "#7A6A51" },
  { name: "Roycroft Mist Gray", code: "SW 2844", hex: "#C2BDB1" },
  { name: "Bunglehouse Gray", code: "SW 2845", hex: "#988F7B" },
  { name: "Roycroft Bronze Green N/A", code: "SW 2846", hex: "#575449" },
  { name: "Roycroft Bottle Green", code: "SW 2847", hex: "#324038" },
  { name: "Roycroft Pewter", code: "SW 2848", hex: "#616564" },
  { name: "Westchester Gray", code: "SW 2849", hex: "#797978" },
  { name: "Chelsea Gray", code: "SW 2850", hex: "#B6B7B0" },
  { name: "Sage Green Light", code: "SW 2851", hex: "#73705E" },
  { name: "New Colonial Yellow", code: "SW 2853", hex: "#D9AD7F" },
  { name: "Caribbean Coral", code: "SW 2854", hex: "#BE795E" },
  { name: "Sycamore Tan", code: "SW 2855", hex: "#9C8A79" },
  { name: "Fairfax Brown", code: "SW 2856", hex: "#61463A" },
  { name: "Peace Yellow", code: "SW 2857", hex: "#EECF9E" },
  { name: "Harvest Gold", code: "SW 2858", hex: "#D9A06A" },
  { name: "Beige", code: "SW 2859", hex: "#DFC8B5" },
  { name: "Sage", code: "SW 2860", hex: "#B3AE95" },
  { name: "Avocado", code: "SW 2861", hex: "#857C5D" },
  { name: "Powder Blue", code: "SW 2863", hex: "#89A4AD" },
  { name: "Classical Yellow", code: "SW 2865", hex: "#F8D492" },
  { name: "Snowfall", code: "SW 6000", hex: "#E0DEDA" },
  { name: "Grayish", code: "SW 6001", hex: "#CFCAC7" },
  { name: "Essential Gray", code: "SW 6002", hex: "#BCB8B6" },
  { name: "Proper Gray", code: "SW 6003", hex: "#ADA8A5" },
  { name: "Mink", code: "SW 6004", hex: "#847B77" },
  { name: "Folkstone", code: "SW 6005", hex: "#6D6562" },
  { name: "Black Bean", code: "SW 6006", hex: "#403330" },
  { name: "Smart White", code: "SW 6007", hex: "#E4DBD8" },
  { name: "Individual White", code: "SW 6008", hex: "#D4CDCA" },
  { name: "Imagine", code: "SW 6009", hex: "#C2B6B6" },
  { name: "Flexible Gray", code: "SW 6010", hex: "#B1A3A1" },
  { name: "Chinchilla", code: "SW 6011", hex: "#867875" },
  { name: "Browse Brown", code: "SW 6012", hex: "#6E615F" },
  { name: "Bitter Chocolate", code: "SW 6013", hex: "#4D3C3C" },
  { name: "Vaguely Mauve", code: "SW 6015", hex: "#D1C5C4" },
  { name: "Chaise Mauve", code: "SW 6016", hex: "#C1B2B3" },
  { name: "Intuitive", code: "SW 6017", hex: "#B3A3A5" },
  { name: "Enigma", code: "SW 6018", hex: "#8B7C7E" },
  { name: "Poetry Plum", code: "SW 6019", hex: "#6F5C5F" },
  { name: "Marooned", code: "SW 6020", hex: "#4E3132" },
  { name: "Dreamy White", code: "SW 6021", hex: "#E3D9D5" },
  { name: "Breathless", code: "SW 6022", hex: "#D6C2BE" },
  { name: "Insightful Rose", code: "SW 6023", hex: "#C9B0AB" },
  { name: "Dressy Rose", code: "SW 6024", hex: "#B89D9A" },
  { name: "Socialite", code: "SW 6025", hex: "#907676" },
  { name: "River Rouge", code: "SW 6026", hex: "#76595D" },
  { name: "Cordovan", code: "SW 6027", hex: "#5F3D3F" },
  { name: "Cultured Pearl", code: "SW 6028", hex: "#E5DCD6" },
  { name: "White Truffle", code: "SW 6029", hex: "#D7C8C2" },
  { name: "Artistic Taupe", code: "SW 6030", hex: "#C3B1AC" },
  { name: "Glamour", code: "SW 6031", hex: "#B6A09A" },
  { name: "Dutch Cocoa", code: "SW 6032", hex: "#8C706A" },
  { name: "Bateau Brown", code: "SW 6033", hex: "#7A5F5A" },
  { name: "Dark Auburn", code: "SW 6034", hex: "#5A3532" },
  { name: "Gauzy White", code: "SW 6035", hex: "#E3DBD4" },
  { name: "Angora", code: "SW 6036", hex: "#D1C5BE" },
  { name: "Temperate Taupe", code: "SW 6037", hex: "#BFB1AA" },
  { name: "Truly Taupe", code: "SW 6038", hex: "#AC9E97" },
  { name: "Poised Taupe", code: "SW 6039", hex: "#8C7E78" },
  { name: "Nutshell", code: "SW 6040", hex: "#756761" },
  { name: "Otter", code: "SW 6041", hex: "#56433B" },
  { name: "Hush White", code: "SW 6042", hex: "#E5DAD4" },
  { name: "Unfussy Beige", code: "SW 6043", hex: "#D6C8C0" },
  { name: "Doeskin", code: "SW 6044", hex: "#C6B3A9" },
  { name: "Emerging Taupe", code: "SW 6045", hex: "#B8A196" },
  { name: "Swing Brown", code: "SW 6046", hex: "#947569" },
  { name: "Hot Cocoa", code: "SW 6047", hex: "#806257" },
  { name: "Terra Brun", code: "SW 6048", hex: "#5A382D" },
  { name: "Gorgeous White", code: "SW 6049", hex: "#E7DBD3" },
  { name: "Abalone Shell", code: "SW 6050", hex: "#DBC7BD" },
  { name: "Sashay Sand", code: "SW 6051", hex: "#CFB4A8" },
  { name: "Sandbank", code: "SW 6052", hex: "#C3A497" },
  { name: "Reddened Earth", code: "SW 6053", hex: "#9C6E63" },
  { name: "Canyon Clay", code: "SW 6054", hex: "#85594F" },
  { name: "Fiery Brown", code: "SW 6055", hex: "#5D3831" },
  { name: "Polite White", code: "SW 6056", hex: "#E9DDD4" },
  { name: "Malted Milk", code: "SW 6057", hex: "#DECABD" },
  { name: "Likeable Sand", code: "SW 6058", hex: "#D1B7A8" },
  { name: "Interface Tan", code: "SW 6059", hex: "#C1A392" },
  { name: "Moroccan Spice", code: "SW 6060", hex: "#9D7868" },
  { name: "Tanbark", code: "SW 6061", hex: "#896656" },
  { name: "Vintage Leather", code: "SW 6062", hex: "#694336" },
  { name: "Nice White", code: "SW 6063", hex: "#E6DDD5" },
  { name: "Reticence", code: "SW 6064", hex: "#D9CDC3" },
  { name: "Bona Fide Beige", code: "SW 6065", hex: "#CBB9AB" },
  { name: "Sand Trap", code: "SW 6066", hex: "#BBA595" },
  { name: "Mocha", code: "SW 6067", hex: "#967A6A" },
  { name: "Brevity Brown", code: "SW 6068", hex: "#715243" },
  { name: "French Roast", code: "SW 6069", hex: "#4F3426" },
  { name: "Heron Plume", code: "SW 6070", hex: "#E5E1D8" },
  { name: "Popular Gray", code: "SW 6071", hex: "#D4CCC3" },
  { name: "Versatile Gray", code: "SW 6072", hex: "#C1B6AB" },
  { name: "Perfect Greige", code: "SW 6073", hex: "#B7AB9F" },
  { name: "Spalding Gray", code: "SW 6074", hex: "#8D7F75" },
  { name: "Garret Gray", code: "SW 6075", hex: "#756861" },
  { name: "Turkish Coffee", code: "SW 6076", hex: "#4D3930" },
  { name: "Everyday White", code: "SW 6077", hex: "#E4DCD4" },
  { name: "Realist Beige", code: "SW 6078", hex: "#D3C8BD" },
  { name: "Diverse Beige", code: "SW 6079", hex: "#C2B4A7" },
  { name: "Utterly Beige", code: "SW 6080", hex: "#B5A597" },
  { name: "Down Home", code: "SW 6081", hex: "#907865" },
  { name: "Cobble Brown", code: "SW 6082", hex: "#7A6455" },
  { name: "Sable", code: "SW 6083", hex: "#5F4B3F" },
  { name: "Modest White", code: "SW 6084", hex: "#E6DDD4" },
  { name: "Simplify Beige", code: "SW 6085", hex: "#D6C7B9" },
  { name: "Sand Dune", code: "SW 6086", hex: "#C5B1A2" },
  { name: "Trusty Tan", code: "SW 6087", hex: "#B59F8F" },
  { name: "Nuthatch", code: "SW 6088", hex: "#8E725F" },
  { name: "Grounded", code: "SW 6089", hex: "#785B47" },
  { name: "Java", code: "SW 6090", hex: "#634533" },
  { name: "Reliable White", code: "SW 6091", hex: "#E8DED3" },
  { name: "Lightweight Beige", code: "SW 6092", hex: "#DAC8B8" },
  { name: "Familiar Beige", code: "SW 6093", hex: "#CAB3A0" },
  { name: "Sensational Sand", code: "SW 6094", hex: "#BFA38D" },
  { name: "Toasty", code: "SW 6095", hex: "#957258" },
  { name: "Jute Brown", code: "SW 6096", hex: "#815D40" },
  { name: "Sturdy Brown", code: "SW 6097", hex: "#69482C" },
  { name: "Pacer White", code: "SW 6098", hex: "#E5DDD0" },
  { name: "Sand Dollar", code: "SW 6099", hex: "#D7C5B3" },
  { name: "Practical Beige", code: "SW 6100", hex: "#C9B29C" },
  { name: "Sands of Time", code: "SW 6101", hex: "#BCA38B" },
  { name: "Portabello", code: "SW 6102", hex: "#947A62" },
  { name: "Tea Chest", code: "SW 6103", hex: "#7D644D" },
  { name: "Kaffee", code: "SW 6104", hex: "#65503D" },
  { name: "Divine White", code: "SW 6105", hex: "#E6DCCD" },
  { name: "Kilim Beige", code: "SW 6106", hex: "#D7C5AE" },
  { name: "Nomadic Desert", code: "SW 6107", hex: "#C7B198" },
  { name: "Latte", code: "SW 6108", hex: "#BAA185" },
  { name: "Hopsack", code: "SW 6109", hex: "#9E8163" },
  { name: "Steady Brown", code: "SW 6110", hex: "#8A6B4D" },
  { name: "Coconut Husk", code: "SW 6111", hex: "#70573F" },
  { name: "Biscuit", code: "SW 6112", hex: "#EBDDCB" },
  { name: "Interactive Cream", code: "SW 6113", hex: "#E4CAAD" },
  { name: "Bagel", code: "SW 6114", hex: "#D7B593" },
  { name: "Totally Tan", code: "SW 6115", hex: "#CCA683" },
  { name: "Tatami Tan", code: "SW 6116", hex: "#BA8C64" },
  { name: "Smokey Topaz", code: "SW 6117", hex: "#A57955" },
  { name: "Leather Bound", code: "SW 6118", hex: "#8D623D" },
  { name: "Antique White", code: "SW 6119", hex: "#E8DCC6" },
  { name: "Believable Buff", code: "SW 6120", hex: "#DBC7A8" },
  { name: "Whole Wheat", code: "SW 6121", hex: "#CDB592" },
  { name: "Camelback", code: "SW 6122", hex: "#C5AA85" },
  { name: "Baguette", code: "SW 6123", hex: "#B39167" },
  { name: "Cardboard", code: "SW 6124", hex: "#9C7A56" },
  { name: "Craft Paper", code: "SW 6125", hex: "#8A6645" },
  { name: "Navajo White", code: "SW 6126", hex: "#E9DCC6" },
  { name: "Ivoire", code: "SW 6127", hex: "#E4CEAC" },
  { name: "Blonde", code: "SW 6128", hex: "#DCBD92" },
  { name: "Restrained Gold", code: "SW 6129", hex: "#D2B084" },
  { name: "Mannered Gold", code: "SW 6130", hex: "#C19763" },
  { name: "Chamois", code: "SW 6131", hex: "#AD8451" },
  { name: "Relic Bronze", code: "SW 6132", hex: "#906A3A" },
  { name: "Muslin", code: "SW 6133", hex: "#EADFC9" },
  { name: "Netsuke", code: "SW 6134", hex: "#E0CFB0" },
  { name: "Ecru", code: "SW 6135", hex: "#D0BA94" },
  { name: "Harmonic Tan", code: "SW 6136", hex: "#C6B08A" },
  { name: "Burlap", code: "SW 6137", hex: "#AC9571" },
  { name: "Artifact", code: "SW 6138", hex: "#9A815E" },
  { name: "Mossy Gold", code: "SW 6139", hex: "#7F6743" },
  { name: "Moderate White", code: "SW 6140", hex: "#E9DECF" },
  { name: "Softer Tan", code: "SW 6141", hex: "#DACAB2" },
  { name: "Macadamia", code: "SW 6142", hex: "#CCB79B" },
  { name: "Basket Beige", code: "SW 6143", hex: "#C0A98B" },
  { name: "Dapper Tan", code: "SW 6144", hex: "#947F65" },
  { name: "Thatch Brown", code: "SW 6145", hex: "#867057" },
  { name: "Umber", code: "SW 6146", hex: "#6E543C" },
  { name: "Panda White", code: "SW 6147", hex: "#EAE2D4" },
  { name: "Wool Skein", code: "SW 6148", hex: "#D9CFBA" },
  { name: "Relaxed Khaki", code: "SW 6149", hex: "#C8BBA3" },
  { name: "Universal Khaki", code: "SW 6150", hex: "#B8A992" },
  { name: "Quiver Tan", code: "SW 6151", hex: "#8E7F6A" },
  { name: "Superior Bronze", code: "SW 6152", hex: "#786957" },
  { name: "Prot\u00e9g\u00e9 Bronze", code: "SW 6153", hex: "#66543E" },
  { name: "Nacre", code: "SW 6154", hex: "#E8E2D4" },
  { name: "Rice Grain", code: "SW 6155", hex: "#DBD0B9" },
  { name: "Ramie", code: "SW 6156", hex: "#CDBDA2" },
  { name: "Favorite Tan", code: "SW 6157", hex: "#C1AE91" },
  { name: "Sawdust", code: "SW 6158", hex: "#998970" },
  { name: "High Tea", code: "SW 6159", hex: "#7E6F59" },
  { name: "Best Bronze", code: "SW 6160", hex: "#5D513E" },
  { name: "Nonchalant White", code: "SW 6161", hex: "#DEDDD1" },
  { name: "Ancient Marble", code: "SW 6162", hex: "#D1CCB9" },
  { name: "Grassland", code: "SW 6163", hex: "#C1BCA7" },
  { name: "Svelte Sage", code: "SW 6164", hex: "#B2AC96" },
  { name: "Connected Gray", code: "SW 6165", hex: "#898473" },
  { name: "Eclipse", code: "SW 6166", hex: "#6B6757" },
  { name: "Garden Gate", code: "SW 6167", hex: "#5E5949" },
  { name: "Moderne White", code: "SW 6168", hex: "#E2E0D7" },
  { name: "Sedate Gray", code: "SW 6169", hex: "#D1CDBF" },
  { name: "Techno Gray", code: "SW 6170", hex: "#BFB9AA" },
  { name: "Chatroom", code: "SW 6171", hex: "#B0AB9C" },
  { name: "Hardware", code: "SW 6172", hex: "#8B8372" },
  { name: "Cocoon", code: "SW 6173", hex: "#726B5B" },
  { name: "Andiron", code: "SW 6174", hex: "#424036" },
  { name: "Sagey", code: "SW 6175", hex: "#E2E2D1" },
  { name: "Liveable Green", code: "SW 6176", hex: "#CECEBD" },
  { name: "Softened Green", code: "SW 6177", hex: "#BBBCA7" },
  { name: "Clary Sage", code: "SW 6178", hex: "#ACAD97" },
  { name: "Artichoke", code: "SW 6179", hex: "#7F8266" },
  { name: "Oakmoss", code: "SW 6180", hex: "#65684C" },
  { name: "Secret Garden", code: "SW 6181", hex: "#4F523A" },
  { name: "Ethereal White", code: "SW 6182", hex: "#E3E2D9" },
  { name: "Conservative Gray", code: "SW 6183", hex: "#D1D0C6" },
  { name: "Austere Gray", code: "SW 6184", hex: "#BEBFB2" },
  { name: "Escape Gray", code: "SW 6185", hex: "#ABAC9F" },
  { name: "Dried Thyme", code: "SW 6186", hex: "#7B8070" },
  { name: "Rosemary", code: "SW 6187", hex: "#64695C" },
  { name: "Shade-Grown", code: "SW 6188", hex: "#4E5147" },
  { name: "Opaline", code: "SW 6189", hex: "#DCDFD7" },
  { name: "Filmy Green", code: "SW 6190", hex: "#D1D3C7" },
  { name: "Contented", code: "SW 6191", hex: "#BDC0B3" },
  { name: "Coastal Plain", code: "SW 6192", hex: "#9FA694" },
  { name: "Privilege Green", code: "SW 6193", hex: "#7A8775" },
  { name: "Basil", code: "SW 6194", hex: "#626E60" },
  { name: "Rock Garden", code: "SW 6195", hex: "#465448" },
  { name: "Frosty White", code: "SW 6196", hex: "#DDDDD6" },
  { name: "Aloof Gray", code: "SW 6197", hex: "#C9C9C0" },
  { name: "Sensible Hue", code: "SW 6198", hex: "#B6B5AB" },
  { name: "Rare Gray", code: "SW 6199", hex: "#A6A69B" },
  { name: "Link Gray", code: "SW 6200", hex: "#7F7E72" },
  { name: "Thunderous", code: "SW 6201", hex: "#6D6C62" },
  { name: "Cast Iron", code: "SW 6202", hex: "#64645A" },
  { name: "Spare White", code: "SW 6203", hex: "#E4E4DD" },
  { name: "Sea Salt", code: "SW 6204", hex: "#CDD2CA" },
  { name: "Comfort Gray", code: "SW 6205", hex: "#BEC3BB" },
  { name: "Oyster Bay", code: "SW 6206", hex: "#AEB3A9" },
  { name: "Retreat", code: "SW 6207", hex: "#7A8076" },
  { name: "Pewter Green", code: "SW 6208", hex: "#5E6259" },
  { name: "Ripe Olive", code: "SW 6209", hex: "#44483D" },
  { name: "Window Pane", code: "SW 6210", hex: "#D7DFD8" },
  { name: "Rainwashed", code: "SW 6211", hex: "#C2CDC5" },
  { name: "Quietude", code: "SW 6212", hex: "#ADBBB2" },
  { name: "Halcyon Green", code: "SW 6213", hex: "#9BAAA2" },
  { name: "Underseas", code: "SW 6214", hex: "#7C8E87" },
  { name: "Rocky River", code: "SW 6215", hex: "#5E706A" },
  { name: "Jasper", code: "SW 6216", hex: "#343B36" },
  { name: "Topsail", code: "SW 6217", hex: "#DAE2E0" },
  { name: "Tradewind", code: "SW 6218", hex: "#C2CFCF" },
  { name: "Rain", code: "SW 6219", hex: "#ABBEBF" },
  { name: "Interesting Aqua", code: "SW 6220", hex: "#9BAFB2" },
  { name: "Moody Blue", code: "SW 6221", hex: "#7A9192" },
  { name: "Riverway", code: "SW 6222", hex: "#5D7274" },
  { name: "Still Water", code: "SW 6223", hex: "#4A5D5F" },
  { name: "Mountain Air", code: "SW 6224", hex: "#D8E0DF" },
  { name: "Sleepy Blue", code: "SW 6225", hex: "#BCCBCE" },
  { name: "Languid Blue", code: "SW 6226", hex: "#A4B7BD" },
  { name: "Meditative", code: "SW 6227", hex: "#96AAB0" },
  { name: "Refuge", code: "SW 6228", hex: "#607D84" },
  { name: "Tempe Star", code: "SW 6229", hex: "#47626A" },
  { name: "Rainstorm", code: "SW 6230", hex: "#244653" },
  { name: "Rock Candy", code: "SW 6231", hex: "#DEE1DF" },
  { name: "Misty", code: "SW 6232", hex: "#CDD2D2" },
  { name: "Samovar Silver", code: "SW 6233", hex: "#B8BEBE" },
  { name: "Uncertain Gray", code: "SW 6234", hex: "#A9B0B1" },
  { name: "Foggy Day", code: "SW 6235", hex: "#727C7F" },
  { name: "Grays Harbor", code: "SW 6236", hex: "#596368" },
  { name: "Dark Night", code: "SW 6237", hex: "#23383F" },
  { name: "Icicle", code: "SW 6238", hex: "#DBDFE0" },
  { name: "Upward", code: "SW 6239", hex: "#BFC9D0" },
  { name: "Windy Blue", code: "SW 6240", hex: "#AABAC6" },
  { name: "Aleutian", code: "SW 6241", hex: "#98A9B7" },
  { name: "Bracing Blue", code: "SW 6242", hex: "#768B9A" },
  { name: "Distance", code: "SW 6243", hex: "#5D6F7F" },
  { name: "Naval", code: "SW 6244", hex: "#2F3D4C" },
  { name: "Quicksilver", code: "SW 6245", hex: "#DDE2E0" },
  { name: "North Star", code: "SW 6246", hex: "#CAD0D2" },
  { name: "Krypton", code: "SW 6247", hex: "#B8C0C3" },
  { name: "Jubilee", code: "SW 6248", hex: "#ADB5B9" },
  { name: "Storm Cloud", code: "SW 6249", hex: "#7A848D" },
  { name: "Granite Peak", code: "SW 6250", hex: "#606B75" },
  { name: "Outerspace", code: "SW 6251", hex: "#586168" },
  { name: "Ice Cube", code: "SW 6252", hex: "#E3E4E1" },
  { name: "Olympus White", code: "SW 6253", hex: "#D4D8D7" },
  { name: "Lazy Gray", code: "SW 6254", hex: "#BEC1C3" },
  { name: "Morning Fog", code: "SW 6255", hex: "#A8AEB1" },
  { name: "Serious Gray", code: "SW 6256", hex: "#7D848B" },
  { name: "Gibraltar", code: "SW 6257", hex: "#626970" },
  { name: "Tricorn Black", code: "SW 6258", hex: "#2F2F30" },
  { name: "Spatial White", code: "SW 6259", hex: "#DDDCDB" },
  { name: "Unique Gray", code: "SW 6260", hex: "#CBC9C9" },
  { name: "Swanky Gray", code: "SW 6261", hex: "#B5B1B5" },
  { name: "Mysterious Mauve", code: "SW 6262", hex: "#A6A3A9" },
  { name: "Exclusive Plum", code: "SW 6263", hex: "#736F78" },
  { name: "Midnight", code: "SW 6264", hex: "#5D5962" },
  { name: "Quixotic Plum", code: "SW 6265", hex: "#4A4653" },
  { name: "Sensitive Tint", code: "SW 6267", hex: "#CEC9CC" },
  { name: "Veiled Violet", code: "SW 6268", hex: "#BDB5B9" },
  { name: "Beguiling Mauve", code: "SW 6269", hex: "#AFA7AC" },
  { name: "Soulmate", code: "SW 6270", hex: "#85777B" },
  { name: "Expressive Plum", code: "SW 6271", hex: "#695C62" },
  { name: "Plum Brown", code: "SW 6272", hex: "#4E4247" },
  { name: "Destiny", code: "SW 6274", hex: "#CFC9C8" },
  { name: "Fashionable Gray", code: "SW 6275", hex: "#BDB8B8" },
  { name: "Mystical Shade", code: "SW 6276", hex: "#AEA9AA" },
  { name: "Special Gray", code: "SW 6277", hex: "#7B787D" },
  { name: "Cloak Gray", code: "SW 6278", hex: "#605E63" },
  { name: "Black Swan", code: "SW 6279", hex: "#3A373E" },
  { name: "Wallflower", code: "SW 6281", hex: "#DBCFD4" },
  { name: "Mauve Finery", code: "SW 6282", hex: "#CBB8C0" },
  { name: "Thistle", code: "SW 6283", hex: "#AA8E9A" },
  { name: "Plum Dandy", code: "SW 6284", hex: "#8B6878" },
  { name: "Grape Harvest", code: "SW 6285", hex: "#7E5A6D" },
  { name: "Mature Grape", code: "SW 6286", hex: "#5F3F54" },
  { name: "Rosebud", code: "SW 6288", hex: "#E0CDD1" },
  { name: "Delightful", code: "SW 6289", hex: "#D2B6BE" },
  { name: "Ros\u00e9", code: "SW 6290", hex: "#B995A1" },
  { name: "Moss Rose", code: "SW 6291", hex: "#9E6D79" },
  { name: "Berry Bush", code: "SW 6292", hex: "#8D5869" },
  { name: "Fabulous Grape", code: "SW 6293", hex: "#6D344F" },
  { name: "Demure", code: "SW 6295", hex: "#E8D4D5" },
  { name: "Fading Rose", code: "SW 6296", hex: "#DABDC1" },
  { name: "Rose Embroidery", code: "SW 6297", hex: "#C79EA2" },
  { name: "Concerto", code: "SW 6298", hex: "#9E6B75" },
  { name: "Aged Wine", code: "SW 6299", hex: "#895460" },
  { name: "Burgundy", code: "SW 6300", hex: "#63333E" },
  { name: "Innocence", code: "SW 6302", hex: "#EBD1CF" },
  { name: "Rose Colored", code: "SW 6303", hex: "#DCB6B5" },
  { name: "Pressed Flower", code: "SW 6304", hex: "#C39393" },
  { name: "Rambling Rose", code: "SW 6305", hex: "#995D62" },
  { name: "Cordial", code: "SW 6306", hex: "#864C52" },
  { name: "Fine Wine", code: "SW 6307", hex: "#723941" },
  { name: "Charming Pink", code: "SW 6309", hex: "#EDD3D2" },
  { name: "Lotus Flower", code: "SW 6310", hex: "#E6BDBD" },
  { name: "Memorable Rose", code: "SW 6311", hex: "#CF8A8D" },
  { name: "Redbud", code: "SW 6312", hex: "#AD5E65" },
  { name: "Kirsch Red", code: "SW 6313", hex: "#974953" },
  { name: "Luxurious Red", code: "SW 6314", hex: "#863A42" },
  { name: "Rosy Outlook", code: "SW 6316", hex: "#EBCECB" },
  { name: "Gracious Rose", code: "SW 6317", hex: "#E3B7B1" },
  { name: "Resounding Rose", code: "SW 6318", hex: "#CD8E89" },
  { name: "Reddish", code: "SW 6319", hex: "#B56966" },
  { name: "Bravado Red", code: "SW 6320", hex: "#A0524E" },
  { name: "Red Bay", code: "SW 6321", hex: "#8E3738" },
  { name: "Intimate White", code: "SW 6322", hex: "#F0E1D8" },
  { name: "Romance", code: "SW 6323", hex: "#EBCFC3" },
  { name: "Mellow Coral", code: "SW 6324", hex: "#E3B5A8" },
  { name: "Constant Coral", code: "SW 6325", hex: "#CD8E7F" },
  { name: "Henna Shade", code: "SW 6326", hex: "#B3675D" },
  { name: "Bold Brick", code: "SW 6327", hex: "#A0584F" },
  { name: "Fireweed", code: "SW 6328", hex: "#7B3730" },
  { name: "Faint Coral", code: "SW 6329", hex: "#EEDED5" },
  { name: "Quaint Peche", code: "SW 6330", hex: "#EACDC1" },
  { name: "Smoky Salmon", code: "SW 6331", hex: "#E2B6A7" },
  { name: "Coral Island", code: "SW 6332", hex: "#CE9382" },
  { name: "Foxy", code: "SW 6333", hex: "#A85E53" },
  { name: "Flower Pot", code: "SW 6334", hex: "#8F4438" },
  { name: "Fired Brick", code: "SW 6335", hex: "#83382A" },
  { name: "Nearly Peach", code: "SW 6336", hex: "#EFDED1" },
  { name: "Spun Sugar", code: "SW 6337", hex: "#EDD2C0" },
  { name: "Warming Peach", code: "SW 6338", hex: "#E4B9A2" },
  { name: "Persimmon", code: "SW 6339", hex: "#D9987C" },
  { name: "Baked Clay", code: "SW 6340", hex: "#C1785C" },
  { name: "Red Cent", code: "SW 6341", hex: "#AD654C" },
  { name: "Spicy Hue", code: "SW 6342", hex: "#994B35" },
  { name: "Alluring White", code: "SW 6343", hex: "#EFE1D2" },
  { name: "Peach Fuzz", code: "SW 6344", hex: "#ECCFBB" },
  { name: "Sumptuous Peach", code: "SW 6345", hex: "#E5B99B" },
  { name: "Fame Orange", code: "SW 6346", hex: "#DB9C7B" },
  { name: "Chrysanthemum", code: "SW 6347", hex: "#C47B5B" },
  { name: "Reynard", code: "SW 6348", hex: "#B46848" },
  { name: "Pennywise", code: "SW 6349", hex: "#A2583A" },
  { name: "Intricate Ivory", code: "SW 6350", hex: "#EDDDCA" },
  { name: "Sweet Orange", code: "SW 6351", hex: "#EBCCB3" },
  { name: "Soft Apricot", code: "SW 6352", hex: "#E0B392" },
  { name: "Chivalry Copper", code: "SW 6353", hex: "#D4966E" },
  { name: "Armagnac", code: "SW 6354", hex: "#C38058" },
  { name: "Truepenny", code: "SW 6355", hex: "#B46C42" },
  { name: "Copper Mountain", code: "SW 6356", hex: "#A6613C" },
  { name: "Choice Cream", code: "SW 6357", hex: "#F0E1D0" },
  { name: "Creamery", code: "SW 6358", hex: "#EDD0B6" },
  { name: "Sociable", code: "SW 6359", hex: "#E8BE9B" },
  { name: "Folksy Gold", code: "SW 6360", hex: "#D69969" },
  { name: "Autumnal", code: "SW 6361", hex: "#CD8C5D" },
  { name: "Tigereye", code: "SW 6362", hex: "#BB7748" },
  { name: "Gingery", code: "SW 6363", hex: "#B06C3E" },
  { name: "Eggwhite", code: "SW 6364", hex: "#F3E5D2" },
  { name: "Cachet Cream", code: "SW 6365", hex: "#F3D9BA" },
  { name: "Ambitious Amber", code: "SW 6366", hex: "#F0CB97" },
  { name: "Viva Gold", code: "SW 6367", hex: "#E3AC72" },
  { name: "Bakelite Gold", code: "SW 6368", hex: "#D7995D" },
  { name: "Tassel", code: "SW 6369", hex: "#C6884A" },
  { name: "Saucy Gold", code: "SW 6370", hex: "#B6743B" },
  { name: "Vanillin", code: "SW 6371", hex: "#F2E3CA" },
  { name: "Inviting Ivory", code: "SW 6372", hex: "#F2D5B0" },
  { name: "Harvester", code: "SW 6373", hex: "#EDC38E" },
  { name: "Torchlight", code: "SW 6374", hex: "#E5AE6B" },
  { name: "Honeycomb", code: "SW 6375", hex: "#D59858" },
  { name: "Gold Coast", code: "SW 6376", hex: "#C78538" },
  { name: "Butterscotch", code: "SW 6377", hex: "#B67D3C" },
  { name: "Crisp Linen", code: "SW 6378", hex: "#F3E6D4" },
  { name: "Jersey Cream", code: "SW 6379", hex: "#F5DEBB" },
  { name: "Humble Gold", code: "SW 6380", hex: "#EDC796" },
  { name: "Anjou Pear", code: "SW 6381", hex: "#DDAC6D" },
  { name: "Ceremonial Gold", code: "SW 6382", hex: "#D69E59" },
  { name: "Golden Rule", code: "SW 6383", hex: "#CC9249" },
  { name: "Cut the Mustard", code: "SW 6384", hex: "#BA7F38" },
  { name: "Dover White", code: "SW 6385", hex: "#F0EADC" },
  { name: "Napery", code: "SW 6386", hex: "#EFDDC1" },
  { name: "Compatible Cream", code: "SW 6387", hex: "#E8C89E" },
  { name: "Golden Fleece", code: "SW 6388", hex: "#D6AD78" },
  { name: "Butternut", code: "SW 6389", hex: "#CC9B5C" },
  { name: "Bosc Pear", code: "SW 6390", hex: "#C09056" },
  { name: "Gallant Gold", code: "SW 6391", hex: "#A4763C" },
  { name: "Vital Yellow", code: "SW 6392", hex: "#EDE0C5" },
  { name: "Convivial Yellow", code: "SW 6393", hex: "#E9D6B0" },
  { name: "Sequin", code: "SW 6394", hex: "#E1C28D" },
  { name: "Alchemy", code: "SW 6395", hex: "#C99E53" },
  { name: "Different Gold", code: "SW 6396", hex: "#BC934D" },
  { name: "Nankeen", code: "SW 6397", hex: "#AA803A" },
  { name: "Sconce Gold", code: "SW 6398", hex: "#996F32" },
  { name: "Chamomile", code: "SW 6399", hex: "#E9E0C5" },
  { name: "Lucent Yellow", code: "SW 6400", hex: "#E4D0A5" },
  { name: "Independent Gold", code: "SW 6401", hex: "#D2BA83" },
  { name: "Antiquity", code: "SW 6402", hex: "#C2A462" },
  { name: "Escapade Gold", code: "SW 6403", hex: "#B89B59" },
  { name: "Grandiose", code: "SW 6404", hex: "#9C7F41" },
  { name: "Fervent Brass", code: "SW 6405", hex: "#95793D" },
  { name: "Ionic Ivory", code: "SW 6406", hex: "#E7DFC5" },
  { name: "Ancestral Gold", code: "SW 6407", hex: "#DDCDA6" },
  { name: "Wheat Grass", code: "SW 6408", hex: "#CBB584" },
  { name: "Edgy Gold", code: "SW 6409", hex: "#B1975F" },
  { name: "Brassy", code: "SW 6410", hex: "#9D8344" },
  { name: "Bengal Grass", code: "SW 6411", hex: "#8E773F" },
  { name: "Eminent Bronze", code: "SW 6412", hex: "#7A6841" },
  { name: "Restoration Ivory", code: "SW 6413", hex: "#E9E1CA" },
  { name: "Rice Paddy", code: "SW 6414", hex: "#DFD4B0" },
  { name: "Hearts of Palm", code: "SW 6415", hex: "#CFC291" },
  { name: "Sassy Green", code: "SW 6416", hex: "#BBA86A" },
  { name: "Tupelo Tree", code: "SW 6417", hex: "#9C9152" },
  { name: "Rural Green", code: "SW 6418", hex: "#8D844D" },
  { name: "Saguaro", code: "SW 6419", hex: "#655F2D" },
  { name: "Queen Anne's Lace", code: "SW 6420", hex: "#ECEAD5" },
  { name: "Celery", code: "SW 6421", hex: "#E0DDBD" },
  { name: "Shagreen", code: "SW 6422", hex: "#CBC99D" },
  { name: "Ryegrass", code: "SW 6423", hex: "#AEAC7A" },
  { name: "Tansy Green", code: "SW 6424", hex: "#95945C" },
  { name: "Relentless Olive", code: "SW 6425", hex: "#71713E" },
  { name: "Basque Green", code: "SW 6426", hex: "#5F6033" },
  { name: "Sprout", code: "SW 6427", hex: "#E4E4CE" },
  { name: "Honeydew", code: "SW 6428", hex: "#DBDDBD" },
  { name: "Baize Green", code: "SW 6429", hex: "#C7CDA8" },
  { name: "Great Green", code: "SW 6430", hex: "#ABB486" },
  { name: "Leapfrog", code: "SW 6431", hex: "#88915D" },
  { name: "Garden Spot", code: "SW 6432", hex: "#6D7645" },
  { name: "Inverness", code: "SW 6433", hex: "#576238" },
  { name: "Spinach White", code: "SW 6434", hex: "#E4E8DA" },
  { name: "Gratifying Green", code: "SW 6435", hex: "#DAE2CD" },
  { name: "Bonsai Tint", code: "SW 6436", hex: "#C5D1B2" },
  { name: "Haven", code: "SW 6437", hex: "#A3B48C" },
  { name: "Dill", code: "SW 6438", hex: "#788D60" },
  { name: "Greenfield", code: "SW 6439", hex: "#60724F" },
  { name: "Courtyard", code: "SW 6440", hex: "#475842" },
  { name: "White Mint", code: "SW 6441", hex: "#E0E7DA" },
  { name: "Supreme Green", code: "SW 6442", hex: "#CFDDC7" },
  { name: "Relish", code: "SW 6443", hex: "#B3CBAA" },
  { name: "Lounge Green", code: "SW 6444", hex: "#8BA97F" },
  { name: "Garden Grove", code: "SW 6445", hex: "#5E7F57" },
  { name: "Arugula", code: "SW 6446", hex: "#42603C" },
  { name: "Evergreens", code: "SW 6447", hex: "#405840" },
  { name: "Topiary Tint", code: "SW 6449", hex: "#C8D8C4" },
  { name: "Easy Green", code: "SW 6450", hex: "#ACC2A8" },
  { name: "Nurture Green", code: "SW 6451", hex: "#98B092" },
  { name: "Inland", code: "SW 6452", hex: "#6C8867" },
  { name: "Cilantro", code: "SW 6453", hex: "#537150" },
  { name: "Shamrock", code: "SW 6454", hex: "#205134" },
  { name: "Fleeting Green", code: "SW 6455", hex: "#D8E2D8" },
  { name: "Slow Green", code: "SW 6456", hex: "#C6D5C9" },
  { name: "Kind Green", code: "SW 6457", hex: "#AAC2B3" },
  { name: "Restful", code: "SW 6458", hex: "#91AF9D" },
  { name: "Jadite", code: "SW 6459", hex: "#61826C" },
  { name: "Kale Green", code: "SW 6460", hex: "#4F6A56" },
  { name: "Isle of Pines", code: "SW 6461", hex: "#3D5541" },
  { name: "Green Trance", code: "SW 6462", hex: "#D7E4DB" },
  { name: "Breaktime", code: "SW 6463", hex: "#C4D9CE" },
  { name: "Aloe", code: "SW 6464", hex: "#ACCABC" },
  { name: "Spearmint", code: "SW 6465", hex: "#94B5A6" },
  { name: "Grandview", code: "SW 6466", hex: "#6B927F" },
  { name: "Kendal Green", code: "SW 6467", hex: "#547867" },
  { name: "Hunt Club", code: "SW 6468", hex: "#2A4F43" },
  { name: "Waterscape", code: "SW 6470", hex: "#BFD2C9" },
  { name: "Hazel", code: "SW 6471", hex: "#A8C1B7" },
  { name: "Composed", code: "SW 6472", hex: "#7EA298" },
  { name: "Surf Green", code: "SW 6473", hex: "#5F887D" },
  { name: "Raging Sea", code: "SW 6474", hex: "#476F65" },
  { name: "Country Squire", code: "SW 6475", hex: "#124A42" },
  { name: "Glimmer", code: "SW 6476", hex: "#E0E7E2" },
  { name: "Tidewater", code: "SW 6477", hex: "#C3D7D3" },
  { name: "Watery", code: "SW 6478", hex: "#B4CCC9" },
  { name: "Drizzle", code: "SW 6479", hex: "#8CAEAB" },
  { name: "Lagoon", code: "SW 6480", hex: "#518682" },
  { name: "Green Bay", code: "SW 6481", hex: "#2E6864" },
  { name: "Cape Verde", code: "SW 6482", hex: "#01554F" },
  { name: "Meander Blue", code: "SW 6484", hex: "#BEDBD8" },
  { name: "Raindrop", code: "SW 6485", hex: "#9EC6C6" },
  { name: "Reflecting Pool", code: "SW 6486", hex: "#7BB1B2" },
  { name: "Cloudburst", code: "SW 6487", hex: "#5C9598" },
  { name: "Grand Canal", code: "SW 6488", hex: "#3C797D" },
  { name: "Really Teal", code: "SW 6489", hex: "#016367" },
  { name: "Open Air", code: "SW 6491", hex: "#C7DFE0" },
  { name: "Jetstream", code: "SW 6492", hex: "#B0D2D6" },
  { name: "Ebbtide", code: "SW 6493", hex: "#84B4BE" },
  { name: "Lakeshore", code: "SW 6494", hex: "#5B96A2" },
  { name: "Great Falls", code: "SW 6495", hex: "#217786" },
  { name: "Oceanside", code: "SW 6496", hex: "#015A6B" },
  { name: "Blue Horizon", code: "SW 6497", hex: "#D8E7E6" },
  { name: "Byte Blue", code: "SW 6498", hex: "#C5DCE0" },
  { name: "Stream", code: "SW 6499", hex: "#ADCCD3" },
  { name: "Open Seas", code: "SW 6500", hex: "#83AFBC" },
  { name: "Manitou Blue", code: "SW 6501", hex: "#5B92A2" },
  { name: "Loch Blue", code: "SW 6502", hex: "#2F778B" },
  { name: "Bosporus", code: "SW 6503", hex: "#015D75" },
  { name: "Sky High", code: "SW 6504", hex: "#DCE7E8" },
  { name: "Atmospheric", code: "SW 6505", hex: "#C2DAE0" },
  { name: "Vast Sky", code: "SW 6506", hex: "#A9C9D7" },
  { name: "Resolute Blue", code: "SW 6507", hex: "#85B0C4" },
  { name: "Secure Blue", code: "SW 6508", hex: "#5389A1" },
  { name: "Georgian Bay", code: "SW 6509", hex: "#22657F" },
  { name: "Loyal Blue", code: "SW 6510", hex: "#01455E" },
  { name: "Snowdrop", code: "SW 6511", hex: "#E0E8E7" },
  { name: "Balmy", code: "SW 6512", hex: "#C5D8DE" },
  { name: "Take Five", code: "SW 6513", hex: "#B3C9D3" },
  { name: "Respite", code: "SW 6514", hex: "#97B4C3" },
  { name: "Leisure Blue", code: "SW 6515", hex: "#6A8EA1" },
  { name: "Down Pour", code: "SW 6516", hex: "#43718B" },
  { name: "Regatta", code: "SW 6517", hex: "#215772" },
  { name: "Hinting Blue", code: "SW 6519", hex: "#CED9DD" },
  { name: "Honest Blue", code: "SW 6520", hex: "#B2C7D3" },
  { name: "Notable Hue", code: "SW 6521", hex: "#8BA7BB" },
  { name: "Sporty Blue", code: "SW 6522", hex: "#6A8AA4" },
  { name: "Denim", code: "SW 6523", hex: "#506B84" },
  { name: "Commodore", code: "SW 6524", hex: "#25476A" },
  { name: "Rarified Air", code: "SW 6525", hex: "#E1E6E6" },
  { name: "Icelandic", code: "SW 6526", hex: "#CBD8E1" },
  { name: "Blissful Blue", code: "SW 6527", hex: "#B2C8D8" },
  { name: "Cosmos", code: "SW 6528", hex: "#8EA9C2" },
  { name: "Scanda", code: "SW 6529", hex: "#6B8CA9" },
  { name: "Revel Blue", code: "SW 6530", hex: "#4C6B8A" },
  { name: "Indigo", code: "SW 6531", hex: "#284A70" },
  { name: "Mild Blue", code: "SW 6533", hex: "#CBD5DB" },
  { name: "Icy", code: "SW 6534", hex: "#BBC7D2" },
  { name: "Solitude", code: "SW 6535", hex: "#99A7B8" },
  { name: "Searching Blue", code: "SW 6536", hex: "#6C7F9A" },
  { name: "Luxe Blue", code: "SW 6537", hex: "#516582" },
  { name: "Dignified", code: "SW 6538", hex: "#3B496D" },
  { name: "Starry Night", code: "SW 6540", hex: "#D6D9DE" },
  { name: "Daydream", code: "SW 6541", hex: "#BDC3CD" },
  { name: "Vesper Violet", code: "SW 6542", hex: "#99A0B2" },
  { name: "Soulful Blue", code: "SW 6543", hex: "#757C91" },
  { name: "Mesmerize", code: "SW 6544", hex: "#5D657B" },
  { name: "Majestic Purple", code: "SW 6545", hex: "#3B3C5A" },
  { name: "Silver Peony", code: "SW 6547", hex: "#DAD6DB" },
  { name: "Grape Mist", code: "SW 6548", hex: "#C5C0C9" },
  { name: "Ash Violet", code: "SW 6549", hex: "#A29BAA" },
  { name: "Mythical", code: "SW 6550", hex: "#7E778E" },
  { name: "Purple Passage", code: "SW 6551", hex: "#645E77" },
  { name: "Dewberry", code: "SW 6552", hex: "#3E385A" },
  { name: "Lite Lavender", code: "SW 6554", hex: "#E0DADF" },
  { name: "Enchant", code: "SW 6555", hex: "#D1C6D2" },
  { name: "Obi Lilac", code: "SW 6556", hex: "#B0A3B6" },
  { name: "Wood Violet", code: "SW 6557", hex: "#7A6B85" },
  { name: "Plummy", code: "SW 6558", hex: "#675A75" },
  { name: "Concord Grape", code: "SW 6559", hex: "#443757" },
  { name: "Teaberry", code: "SW 6561", hex: "#EBD1DB" },
  { name: "Irresistible", code: "SW 6562", hex: "#E3C0CF" },
  { name: "Rosebay", code: "SW 6563", hex: "#CB9AAD" },
  { name: "Red Clover", code: "SW 6564", hex: "#B87E93" },
  { name: "Grandeur Plum", code: "SW 6565", hex: "#92576F" },
  { name: "Framboise", code: "SW 6566", hex: "#7C3655" },
  { name: "Lighthearted Pink", code: "SW 6568", hex: "#EDD5DD" },
  { name: "Childlike", code: "SW 6569", hex: "#E8C0CF" },
  { name: "Haute Pink", code: "SW 6570", hex: "#D899B1" },
  { name: "Cyclamen", code: "SW 6571", hex: "#C47B95" },
  { name: "Ruby Shade", code: "SW 6572", hex: "#A2566F" },
  { name: "Juneberry", code: "SW 6573", hex: "#854158" },
  { name: "Priscilla", code: "SW 6575", hex: "#F1D3DA" },
  { name: "Azalea Flower", code: "SW 6576", hex: "#EFC0CB" },
  { name: "Jaipur Pink", code: "SW 6577", hex: "#E392A1" },
  { name: "Tuberose", code: "SW 6578", hex: "#D47C8C" },
  { name: "Gala Pink", code: "SW 6579", hex: "#B04B63" },
  { name: "Cerise", code: "SW 6580", hex: "#99324E" },
  { name: "Impatiens Petal", code: "SW 6582", hex: "#F1D2D7" },
  { name: "In the Pink", code: "SW 6583", hex: "#F0BCC9" },
  { name: "Cheery", code: "SW 6584", hex: "#EB92A3" },
  { name: "Coming up Roses", code: "SW 6585", hex: "#DD7788" },
  { name: "Heartfelt", code: "SW 6586", hex: "#BD4C5F" },
  { name: "Valentine", code: "SW 6587", hex: "#A53A4E" },
  { name: "Alyssum", code: "SW 6589", hex: "#F2D5D7" },
  { name: "Loveable", code: "SW 6590", hex: "#F0C1C6" },
  { name: "Amaryllis", code: "SW 6591", hex: "#ED939D" },
  { name: "Grenadine", code: "SW 6592", hex: "#D66972" },
  { name: "Coral Bells", code: "SW 6593", hex: "#BB4B51" },
  { name: "Poinsettia", code: "SW 6594", hex: "#9D373C" },
  { name: "Bella Pink", code: "SW 6596", hex: "#F1C6C4" },
  { name: "Hopeful", code: "SW 6597", hex: "#F0B3B2" },
  { name: "Dishy Coral", code: "SW 6598", hex: "#ED9190" },
  { name: "Begonia", code: "SW 6599", hex: "#D76C6E" },
  { name: "Enticing Red", code: "SW 6600", hex: "#B74E4F" },
  { name: "Tanager", code: "SW 6601", hex: "#A43834" },
  { name: "Oleander", code: "SW 6603", hex: "#F2CCC5" },
  { name: "Youthful Coral", code: "SW 6604", hex: "#F0AFA8" },
  { name: "Charisma", code: "SW 6605", hex: "#EE9489" },
  { name: "Coral Reef", code: "SW 6606", hex: "#D9766C" },
  { name: "Red Tomato", code: "SW 6607", hex: "#B24743" },
  { name: "Rave Red", code: "SW 6608", hex: "#A13B34" },
  { name: "Koral Kicks", code: "SW 6610", hex: "#F2D1C3" },
  { name: "Jovial", code: "SW 6611", hex: "#F2B8A7" },
  { name: "Ravishing Coral", code: "SW 6612", hex: "#E79580" },
  { name: "Lei Flower", code: "SW 6613", hex: "#D87B6A" },
  { name: "Quite Coral", code: "SW 6614", hex: "#C76356" },
  { name: "Peppery", code: "SW 6615", hex: "#B85444" },
  { name: "Blushing", code: "SW 6617", hex: "#F0D1C3" },
  { name: "Cosmetic Peach", code: "SW 6618", hex: "#F3C1AB" },
  { name: "Sockeye", code: "SW 6619", hex: "#E49780" },
  { name: "Rejuvenate", code: "SW 6620", hex: "#DD7861" },
  { name: "Emotional", code: "SW 6621", hex: "#C65F47" },
  { name: "Hearty Orange", code: "SW 6622", hex: "#B44B34" },
  { name: "Peach Blossom", code: "SW 6624", hex: "#F3D0BD" },
  { name: "Certain Peach", code: "SW 6625", hex: "#F2BDA2" },
  { name: "Sunset", code: "SW 6626", hex: "#E2946F" },
  { name: "Emberglow", code: "SW 6627", hex: "#D67C56" },
  { name: "Robust Orange", code: "SW 6628", hex: "#C4633E" },
  { name: "Jalape\u00f1o", code: "SW 6629", hex: "#B1533C" },
  { name: "Naive Peach", code: "SW 6631", hex: "#F3D3BF" },
  { name: "Neighborly Peach", code: "SW 6632", hex: "#F3C1A3" },
  { name: "Inventive Orange", code: "SW 6633", hex: "#E89D6F" },
  { name: "Copper Harbor", code: "SW 6634", hex: "#D57E52" },
  { name: "Determined Orange", code: "SW 6635", hex: "#C56639" },
  { name: "Husky Orange", code: "SW 6636", hex: "#BB613E" },
  { name: "Flattering Peach", code: "SW 6638", hex: "#F4D3B3" },
  { name: "Avid Apricot", code: "SW 6639", hex: "#F4C69F" },
  { name: "Tangerine", code: "SW 6640", hex: "#F2AC78" },
  { name: "Outgoing Orange", code: "SW 6641", hex: "#E6955F" },
  { name: "Rhumba Orange", code: "SW 6642", hex: "#CB7841" },
  { name: "Yam", code: "SW 6643", hex: "#C36F3E" },
  { name: "Champagne", code: "SW 6644", hex: "#F2E3CE" },
  { name: "Flan", code: "SW 6652", hex: "#F4D4AF" },
  { name: "Delicious Melon", code: "SW 6653", hex: "#F5C894" },
  { name: "Surprise Amber", code: "SW 6654", hex: "#EFB57A" },
  { name: "Adventure Orange", code: "SW 6655", hex: "#E69F5F" },
  { name: "Serape", code: "SW 6656", hex: "#D88B4D" },
  { name: "Amber Wave", code: "SW 6657", hex: "#D28240" },
  { name: "Welcome White", code: "SW 6658", hex: "#F3E3CA" },
  { name: "Captivating Cream", code: "SW 6659", hex: "#F4D9B1" },
  { name: "Honey Blush", code: "SW 6660", hex: "#F5CF9B" },
  { name: "Papaya", code: "SW 6661", hex: "#EFB97B" },
  { name: "Summer Day", code: "SW 6662", hex: "#EAAA62" },
  { name: "Saffron Thread", code: "SW 6663", hex: "#DF984E" },
  { name: "Marigold", code: "SW 6664", hex: "#D28233" },
  { name: "Gardenia", code: "SW 6665", hex: "#F3E2C9" },
  { name: "Enjoyable Yellow", code: "SW 6666", hex: "#F5D6A9" },
  { name: "Afterglow", code: "SW 6667", hex: "#F6CD8E" },
  { name: "Sunrise", code: "SW 6668", hex: "#F4BF77" },
  { name: "Yarrow", code: "SW 6669", hex: "#EBAD5E" },
  { name: "Gold Crest", code: "SW 6670", hex: "#DF9938" },
  { name: "Curry", code: "SW 6671", hex: "#D88F32" },
  { name: "Morning Sun", code: "SW 6672", hex: "#F3E6CE" },
  { name: "Banana Cream", code: "SW 6673", hex: "#F5DEAF" },
  { name: "Jonquil", code: "SW 6674", hex: "#F7D391" },
  { name: "Afternoon", code: "SW 6675", hex: "#FBCB78" },
  { name: "Butterfield", code: "SW 6676", hex: "#F7BE5B" },
  { name: "Goldenrod", code: "SW 6677", hex: "#F2AF46" },
  { name: "Sunflower", code: "SW 6678", hex: "#E39A33" },
  { name: "Full Moon", code: "SW 6679", hex: "#F4E3BC" },
  { name: "Friendly Yellow", code: "SW 6680", hex: "#F5E0B1" },
  { name: "Butter Up", code: "SW 6681", hex: "#F6DDA3" },
  { name: "June Day", code: "SW 6682", hex: "#F6C973" },
  { name: "Bee", code: "SW 6683", hex: "#F1BA55" },
  { name: "Brittlebush", code: "SW 6684", hex: "#EAAE47" },
  { name: "Trinket", code: "SW 6685", hex: "#D69835" },
  { name: "Lemon Chiffon", code: "SW 6686", hex: "#F5E5BC" },
  { name: "Lantern Light", code: "SW 6687", hex: "#F4E1AE" },
  { name: "Solaria", code: "SW 6688", hex: "#F5D68F" },
  { name: "Overjoy", code: "SW 6689", hex: "#EEC25F" },
  { name: "Gambol Gold", code: "SW 6690", hex: "#E1B047" },
  { name: "Glitzy Gold", code: "SW 6691", hex: "#D6A02B" },
  { name: "Auric", code: "SW 6692", hex: "#C48919" },
  { name: "Lily", code: "SW 6693", hex: "#F3E8C2" },
  { name: "Glad Yellow", code: "SW 6694", hex: "#F5E1AC" },
  { name: "Midday", code: "SW 6695", hex: "#F7D78A" },
  { name: "Quilt Gold", code: "SW 6696", hex: "#EAC365" },
  { name: "Nugget", code: "SW 6697", hex: "#DBB04A" },
  { name: "Kingdom Gold", code: "SW 6698", hex: "#D1A436" },
  { name: "Crispy Gold", code: "SW 6699", hex: "#C49832" },
  { name: "Daybreak", code: "SW 6700", hex: "#F3EAC6" },
  { name: "Moonraker", code: "SW 6701", hex: "#EEE3B2" },
  { name: "Lively Yellow", code: "SW 6702", hex: "#E6D88E" },
  { name: "Frolic", code: "SW 6703", hex: "#D9C661" },
  { name: "Hep Green", code: "SW 6704", hex: "#C4B146" },
  { name: "High Strung", code: "SW 6705", hex: "#AC9825" },
  { name: "Offbeat Green", code: "SW 6706", hex: "#9C8B1F" },
  { name: "Springtime", code: "SW 6708", hex: "#E9E5B3" },
  { name: "Gleeful", code: "SW 6709", hex: "#DAD790" },
  { name: "M\u00e9lange Green", code: "SW 6710", hex: "#C4C476" },
  { name: "Parakeet", code: "SW 6711", hex: "#B4B05A" },
  { name: "Luau Green", code: "SW 6712", hex: "#989746" },
  { name: "Verdant", code: "SW 6713", hex: "#847E35" },
  { name: "Lime Granita", code: "SW 6715", hex: "#DCE1B8" },
  { name: "Dancing Green", code: "SW 6716", hex: "#C5CD8F" },
  { name: "Lime Rickey", code: "SW 6717", hex: "#AFB96A" },
  { name: "Overt Green", code: "SW 6718", hex: "#97A554" },
  { name: "Gecko", code: "SW 6719", hex: "#7A8833" },
  { name: "Paradise", code: "SW 6720", hex: "#6C7B30" },
  { name: "Cucumber", code: "SW 6722", hex: "#D3DFC3" },
  { name: "Jardin", code: "SW 6723", hex: "#BDD0AB" },
  { name: "Mesclun Green", code: "SW 6724", hex: "#9DB682" },
  { name: "Pickle", code: "SW 6725", hex: "#85A16A" },
  { name: "Talipot Palm", code: "SW 6726", hex: "#648149" },
  { name: "Houseplant", code: "SW 6727", hex: "#58713F" },
  { name: "Lacewing", code: "SW 6729", hex: "#D7E3CA" },
  { name: "Romaine", code: "SW 6730", hex: "#C0D2AD" },
  { name: "Picnic", code: "SW 6731", hex: "#99C285" },
  { name: "Organic Green", code: "SW 6732", hex: "#7FAC6E" },
  { name: "Grasshopper", code: "SW 6733", hex: "#4F854A" },
  { name: "Espalier", code: "SW 6734", hex: "#2F5F3A" },
  { name: "Jocular Green", code: "SW 6736", hex: "#CCE2CA" },
  { name: "Kiwi", code: "SW 6737", hex: "#AED2B0" },
  { name: "Vegan", code: "SW 6738", hex: "#8EC298" },
  { name: "Eco Green", code: "SW 6739", hex: "#68A678" },
  { name: "Kilkenny", code: "SW 6740", hex: "#498555" },
  { name: "Derbyshire", code: "SW 6741", hex: "#245E36" },
  { name: "Mint Condition", code: "SW 6743", hex: "#D1E3D2" },
  { name: "Reclining Green", code: "SW 6744", hex: "#B7D7BF" },
  { name: "Lark Green", code: "SW 6745", hex: "#8AC1A1" },
  { name: "Julep", code: "SW 6746", hex: "#57AA80" },
  { name: "Argyle", code: "SW 6747", hex: "#348A5D" },
  { name: "Greens", code: "SW 6748", hex: "#016844" },
  { name: "Embellished Blue", code: "SW 6749", hex: "#D7EBE2" },
  { name: "Waterfall", code: "SW 6750", hex: "#C0E3DA" },
  { name: "Refresh", code: "SW 6751", hex: "#A1D4C8" },
  { name: "Larchmere", code: "SW 6752", hex: "#70BAA7" },
  { name: "Jargon Jade", code: "SW 6753", hex: "#53A38F" },
  { name: "Ionian", code: "SW 6754", hex: "#368976" },
  { name: "Starboard", code: "SW 6755", hex: "#016C4F" },
  { name: "Tame Teal", code: "SW 6757", hex: "#C1E6DF" },
  { name: "Aqueduct", code: "SW 6758", hex: "#A1D5CB" },
  { name: "Cooled Blue", code: "SW 6759", hex: "#75B9AE" },
  { name: "Rivulet", code: "SW 6760", hex: "#61A89D" },
  { name: "Thermal Spring", code: "SW 6761", hex: "#3B8C80" },
  { name: "Poseidon", code: "SW 6762", hex: "#016D60" },
  { name: "Swimming", code: "SW 6764", hex: "#C2E5E5" },
  { name: "Spa", code: "SW 6765", hex: "#A7DCDC" },
  { name: "Mariner", code: "SW 6766", hex: "#6EC2C4" },
  { name: "Aquarium", code: "SW 6767", hex: "#3AA9AE" },
  { name: "Gulfstream", code: "SW 6768", hex: "#01858B" },
  { name: "Maxi Teal", code: "SW 6769", hex: "#017478" },
  { name: "Bathe Blue", code: "SW 6771", hex: "#C2E0E3" },
  { name: "Cay", code: "SW 6772", hex: "#A6D0D6" },
  { name: "Rapture Blue", code: "SW 6773", hex: "#7DC1CB" },
  { name: "Freshwater", code: "SW 6774", hex: "#4DA6B2" },
  { name: "Briny", code: "SW 6775", hex: "#08808E" },
  { name: "Blue Nile", code: "SW 6776", hex: "#01717E" },
  { name: "Aviary Blue", code: "SW 6778", hex: "#C6E3E8" },
  { name: "Liquid Blue", code: "SW 6779", hex: "#A6D4DE" },
  { name: "Nautilus", code: "SW 6780", hex: "#71B8C7" },
  { name: "Jamaica Bay", code: "SW 6781", hex: "#34A3B6" },
  { name: "Cruising", code: "SW 6782", hex: "#018498" },
  { name: "Amalfi", code: "SW 6783", hex: "#016E85" },
  { name: "Bravo Blue", code: "SW 6784", hex: "#D3E7E9" },
  { name: "Quench Blue", code: "SW 6785", hex: "#B4E0E7" },
  { name: "Cloudless", code: "SW 6786", hex: "#8FD0DD" },
  { name: "Fountain", code: "SW 6787", hex: "#56B5CA" },
  { name: "Capri", code: "SW 6788", hex: "#01A0B8" },
  { name: "Blue Mosque", code: "SW 6789", hex: "#01819E" },
  { name: "Adriatic Sea", code: "SW 6790", hex: "#016081" },
  { name: "Minor Blue", code: "SW 6792", hex: "#B7DFE8" },
  { name: "Bluebell", code: "SW 6793", hex: "#A2D5E7" },
  { name: "Flyway", code: "SW 6794", hex: "#5DB3D4" },
  { name: "Major Blue", code: "SW 6795", hex: "#289EC4" },
  { name: "Blue Plate", code: "SW 6796", hex: "#017CA7" },
  { name: "Jay Blue", code: "SW 6797", hex: "#015D87" },
  { name: "Iceberg", code: "SW 6798", hex: "#D6E4E7" },
  { name: "Soar", code: "SW 6799", hex: "#C3DFE8" },
  { name: "Something Blue", code: "SW 6800", hex: "#B0D6E6" },
  { name: "Regale Blue", code: "SW 6801", hex: "#7DB5D3" },
  { name: "Jacaranda", code: "SW 6802", hex: "#5A9EC0" },
  { name: "Danube", code: "SW 6803", hex: "#2377A2" },
  { name: "Dignity Blue", code: "SW 6804", hex: "#094C73" },
  { name: "Rhythmic Blue", code: "SW 6806", hex: "#CCDBE5" },
  { name: "Wondrous Blue", code: "SW 6807", hex: "#B8CDDD" },
  { name: "Celestial", code: "SW 6808", hex: "#97B3D0" },
  { name: "Lobelia", code: "SW 6809", hex: "#7498BE" },
  { name: "Lupine", code: "SW 6810", hex: "#4E739F" },
  { name: "Honorable Blue", code: "SW 6811", hex: "#164576" },
  { name: "Wishful Blue", code: "SW 6813", hex: "#D8DDE6" },
  { name: "Breathtaking", code: "SW 6814", hex: "#C7D1E2" },
  { name: "Awesome Violet", code: "SW 6815", hex: "#A7B2D4" },
  { name: "Dahlia", code: "SW 6816", hex: "#8B98C4" },
  { name: "Gentian", code: "SW 6817", hex: "#6572A5" },
  { name: "Valiant Violet", code: "SW 6818", hex: "#3E4371" },
  { name: "Inspired Lilac", code: "SW 6820", hex: "#DFD9E4" },
  { name: "Potentially Purple", code: "SW 6821", hex: "#D1CBDF" },
  { name: "Wisteria", code: "SW 6822", hex: "#BDB4D4" },
  { name: "Brave Purple", code: "SW 6823", hex: "#968DB8" },
  { name: "Forget-Me-Not", code: "SW 6824", hex: "#716998" },
  { name: "Izmir Purple", code: "SW 6825", hex: "#4D426E" },
  { name: "Elation", code: "SW 6827", hex: "#DFDCE5" },
  { name: "Rhapsody Lilac", code: "SW 6828", hex: "#D2C8DD" },
  { name: "Magical", code: "SW 6829", hex: "#C0AFD0" },
  { name: "Kismet", code: "SW 6830", hex: "#A18AB7" },
  { name: "Clematis", code: "SW 6831", hex: "#7E6596" },
  { name: "Impulsive Purple", code: "SW 6832", hex: "#624977" },
  { name: "Spangle", code: "SW 6834", hex: "#E5DBE5" },
  { name: "Euphoric Lilac", code: "SW 6835", hex: "#DAC7DA" },
  { name: "Novel Lilac", code: "SW 6836", hex: "#C2A4C2" },
  { name: "Baroness", code: "SW 6837", hex: "#A785A7" },
  { name: "Vigorous Violet", code: "SW 6838", hex: "#7C5A7E" },
  { name: "Kimono Violet", code: "SW 6839", hex: "#5D395F" },
  { name: "Exuberant Pink", code: "SW 6840", hex: "#B54D7F" },
  { name: "Dynamo", code: "SW 6841", hex: "#953D68" },
  { name: "Forward Fuchsia", code: "SW 6842", hex: "#92345B" },
  { name: "Hot", code: "SW 6843", hex: "#AC4362" },
  { name: "Dragon Fruit", code: "SW 6855", hex: "#CC617F" },
  { name: "Eros Pink", code: "SW 6860", hex: "#C84F68" },
  { name: "Radish", code: "SW 6861", hex: "#A42E41" },
  { name: "Cherries Jubilee", code: "SW 6862", hex: "#AB3C51" },
  { name: "Heartthrob", code: "SW 6866", hex: "#A82E33" },
  { name: "Real Red", code: "SW 6868", hex: "#BF2D32" },
  { name: "Stop", code: "SW 6869", hex: "#C33A36" },
  { name: "Positive Red", code: "SW 6871", hex: "#AD2C34" },
  { name: "Comical Coral", code: "SW 6876", hex: "#F3D1C8" },
  { name: "Cayenne", code: "SW 6881", hex: "#C04D35" },
  { name: "Raucous Orange", code: "SW 6883", hex: "#C35530" },
  { name: "Obstinate Orange", code: "SW 6884", hex: "#D7552A" },
  { name: "Knockout Orange", code: "SW 6885", hex: "#E16F3E" },
  { name: "Invigorate", code: "SW 6886", hex: "#E47237" },
  { name: "Navel", code: "SW 6887", hex: "#EC8430" },
  { name: "Osage Orange", code: "SW 6890", hex: "#F4A045" },
  { name: "Carnival", code: "SW 6892", hex: "#EB882C" },
  { name: "Sol\u00e9", code: "SW 6896", hex: "#F7DDA1" },
  { name: "Optimistic Yellow", code: "SW 6900", hex: "#F5E1A6" },
  { name: "Daffodil", code: "SW 6901", hex: "#FAD97A" },
  { name: "Decisive Yellow", code: "SW 6902", hex: "#FDCC4E" },
  { name: "Cheerful", code: "SW 6903", hex: "#FFC723" },
  { name: "Gusto Gold", code: "SW 6904", hex: "#F8AC1D" },
  { name: "Goldfinch", code: "SW 6905", hex: "#FDB702" },
  { name: "Forsythia", code: "SW 6907", hex: "#FFC801" },
  { name: "Fun Yellow", code: "SW 6908", hex: "#F7E594" },
  { name: "Lemon Twist", code: "SW 6909", hex: "#FED95D" },
  { name: "Daisy", code: "SW 6910", hex: "#FED340" },
  { name: "Confident Yellow", code: "SW 6911", hex: "#FECB01" },
  { name: "Funky Yellow", code: "SW 6913", hex: "#EDD26F" },
  { name: "Eye Catching", code: "SW 6914", hex: "#DDB835" },
  { name: "Citronella", code: "SW 6915", hex: "#CBA901" },
  { name: "Humorous Green", code: "SW 6918", hex: "#C6B836" },
  { name: "Center Stage", code: "SW 6920", hex: "#B2C216" },
  { name: "Electric Lime", code: "SW 6921", hex: "#9ABA25" },
  { name: "Direct Green", code: "SW 6924", hex: "#3F8A24" },
  { name: "Envy", code: "SW 6925", hex: "#358C3F" },
  { name: "Lucky Green", code: "SW 6926", hex: "#238652" },
  { name: "Greenbelt", code: "SW 6927", hex: "#017244" },
  { name: "Green Vibes", code: "SW 6928", hex: "#D4E7C3" },
  { name: "Tantalizing Teal", code: "SW 6937", hex: "#87DCCE" },
  { name: "Nifty Turquoise", code: "SW 6941", hex: "#019187" },
  { name: "Splashy", code: "SW 6942", hex: "#019196" },
  { name: "Intense Teal", code: "SW 6943", hex: "#017680" },
  { name: "Calypso", code: "SW 6950", hex: "#01B0BB" },
  { name: "Undercool", code: "SW 6957", hex: "#7FC3E1" },
  { name: "Dynamic Blue", code: "SW 6958", hex: "#0192C6" },
  { name: "Blue Chip", code: "SW 6959", hex: "#016EA7" },
  { name: "Hyper Blue", code: "SW 6965", hex: "#015F97" },
  { name: "Blueblood", code: "SW 6966", hex: "#015086" },
  { name: "Frank Blue", code: "SW 6967", hex: "#225288" },
  { name: "Hyacinth Tint", code: "SW 6968", hex: "#C2CBE0" },
  { name: "Morning Glory", code: "SW 6971", hex: "#3C4C80" },
  { name: "Free Spirit", code: "SW 6973", hex: "#CAB2D2" },
  { name: "Passionate Purple", code: "SW 6981", hex: "#795484" },
  { name: "African Violet", code: "SW 6982", hex: "#665385" },
  { name: "Fully Purple", code: "SW 6983", hex: "#514C7E" },
  { name: "Jitterbug Jade", code: "SW 6987", hex: "#019D6E" },
  { name: "Bohemian Black", code: "SW 6988", hex: "#3B373C" },
  { name: "Domino", code: "SW 6989", hex: "#353337" },
  { name: "Caviar", code: "SW 6990", hex: "#313031" },
  { name: "Black Magic", code: "SW 6991", hex: "#323132" },
  { name: "Inkwell", code: "SW 6992", hex: "#31363A" },
  { name: "Black of Night", code: "SW 6993", hex: "#323639" },
  { name: "Greenblack", code: "SW 6994", hex: "#373A3A" },
  { name: "Ibis White", code: "SW 7000", hex: "#F2ECE6" },
  { name: "Marshmallow", code: "SW 7001", hex: "#EEE9E0" },
  { name: "Downy", code: "SW 7002", hex: "#EFE8DD" },
  { name: "Toque White", code: "SW 7003", hex: "#E7E2DA" },
  { name: "Snowbound", code: "SW 7004", hex: "#EDEAE5" },
  { name: "Pure White", code: "SW 7005", hex: "#EDECE6" },
  { name: "Extra White", code: "SW 7006", hex: "#EEEFEA" },
  { name: "Ceiling Bright White", code: "SW 7007", hex: "#E9EBE7" },
  { name: "Alabaster", code: "SW 7008", hex: "#EDEAE0" },
  { name: "Pearly White", code: "SW 7009", hex: "#E8E3D9" },
  { name: "White Duck", code: "SW 7010", hex: "#E5DFD2" },
  { name: "Natural Choice", code: "SW 7011", hex: "#E3DED0" },
  { name: "Creamy", code: "SW 7012", hex: "#EFE8DB" },
  { name: "Ivory Lace", code: "SW 7013", hex: "#ECE5D8" },
  { name: "Eider White", code: "SW 7014", hex: "#E2DED8" },
  { name: "Repose Gray", code: "SW 7015", hex: "#CCC9C0" },
  { name: "Mindful Gray", code: "SW 7016", hex: "#BCB7AD" },
  { name: "Dorian Gray", code: "SW 7017", hex: "#ACA79E" },
  { name: "Dovetail", code: "SW 7018", hex: "#908A83" },
  { name: "Gauntlet Gray", code: "SW 7019", hex: "#78736E" },
  { name: "Black Fox", code: "SW 7020", hex: "#4F4842" },
  { name: "Simple White", code: "SW 7021", hex: "#DFD9D2" },
  { name: "Alpaca", code: "SW 7022", hex: "#CCC5BD" },
  { name: "Requisite Gray", code: "SW 7023", hex: "#B9B2A9" },
  { name: "Functional Gray", code: "SW 7024", hex: "#ABA39A" },
  { name: "Backdrop", code: "SW 7025", hex: "#867A6F" },
  { name: "Griffin", code: "SW 7026", hex: "#6F6459" },
  { name: "Hickory Smoke", code: "SW 7027", hex: "#564537" },
  { name: "Incredible White", code: "SW 7028", hex: "#E3DED7" },
  { name: "Agreeable Gray", code: "SW 7029", hex: "#D1CBC1" },
  { name: "Anew Gray", code: "SW 7030", hex: "#BFB6AA" },
  { name: "Mega Greige", code: "SW 7031", hex: "#ADA295" },
  { name: "Warm Stone", code: "SW 7032", hex: "#887B6C" },
  { name: "Brainstorm Bronze", code: "SW 7033", hex: "#74685A" },
  { name: "Status Bronze", code: "SW 7034", hex: "#5C4D3C" },
  { name: "Aesthetic White", code: "SW 7035", hex: "#E3DDD3" },
  { name: "Accessible Beige", code: "SW 7036", hex: "#D1C7B8" },
  { name: "Balanced Beige", code: "SW 7037", hex: "#C0B2A2" },
  { name: "Tony Taupe", code: "SW 7038", hex: "#B1A290" },
  { name: "Virtual Taupe", code: "SW 7039", hex: "#8A7A6A" },
  { name: "Smokehouse", code: "SW 7040", hex: "#716354" },
  { name: "Van Dyke Brown", code: "SW 7041", hex: "#564536" },
  { name: "Shoji White", code: "SW 7042", hex: "#E6DFD3" },
  { name: "Worldly Gray", code: "SW 7043", hex: "#CEC6BB" },
  { name: "Amazing Gray", code: "SW 7044", hex: "#BEB5A9" },
  { name: "Intellectual Gray", code: "SW 7045", hex: "#A8A093" },
  { name: "Anonymous", code: "SW 7046", hex: "#817A6E" },
  { name: "Porpoise", code: "SW 7047", hex: "#6B645B" },
  { name: "Urbane Bronze", code: "SW 7048", hex: "#54504A" },
  { name: "Nuance", code: "SW 7049", hex: "#E2E0D6" },
  { name: "Useful Gray", code: "SW 7050", hex: "#CFCABD" },
  { name: "Analytical Gray", code: "SW 7051", hex: "#BFB6A7" },
  { name: "Gray Area", code: "SW 7052", hex: "#AFA696" },
  { name: "Adaptive Shade", code: "SW 7053", hex: "#867E70" },
  { name: "Oak Leaf Brown", code: "SW 7054", hex: "#645A4B" },
  { name: "Enduring Bronze", code: "SW 7055", hex: "#554C3E" },
  { name: "Reserved White", code: "SW 7056", hex: "#E0E0D9" },
  { name: "Silver Strand", code: "SW 7057", hex: "#C8CBC4" },
  { name: "Magnetic Gray", code: "SW 7058", hex: "#B2B5AF" },
  { name: "Unusual Gray", code: "SW 7059", hex: "#A3A7A0" },
  { name: "Attitude Gray", code: "SW 7060", hex: "#7C7D75" },
  { name: "Night Owl", code: "SW 7061", hex: "#63655F" },
  { name: "Rock Bottom", code: "SW 7062", hex: "#484C49" },
  { name: "Nebulous White", code: "SW 7063", hex: "#DEDFDC" },
  { name: "Passive", code: "SW 7064", hex: "#CBCCC9" },
  { name: "Argos", code: "SW 7065", hex: "#BDBDB7" },
  { name: "Gray Matters", code: "SW 7066", hex: "#A7A8A2" },
  { name: "Cityscape", code: "SW 7067", hex: "#7F817E" },
  { name: "Grizzle Gray", code: "SW 7068", hex: "#636562" },
  { name: "Iron Ore", code: "SW 7069", hex: "#434341" },
  { name: "Site White", code: "SW 7070", hex: "#DCDEDC" },
  { name: "Gray Screen", code: "SW 7071", hex: "#C6CACA" },
  { name: "Online", code: "SW 7072", hex: "#B0B5B5" },
  { name: "Network Gray", code: "SW 7073", hex: "#A0A5A7" },
  { name: "Software", code: "SW 7074", hex: "#7F8486" },
  { name: "Web Gray", code: "SW 7075", hex: "#616669" },
  { name: "Cyberspace", code: "SW 7076", hex: "#44484D" },
  { name: "Original White", code: "SW 7077", hex: "#E2DEDB" },
  { name: "Minute Mauve", code: "SW 7078", hex: "#CFC9C8" },
  { name: "Ponder", code: "SW 7079", hex: "#BCB6B6" },
  { name: "Quest Gray", code: "SW 7080", hex: "#ADA5A5" },
  { name: "Sensuous Gray", code: "SW 7081", hex: "#837D7F" },
  { name: "Stunning Shade", code: "SW 7082", hex: "#676064" },
  { name: "Darkroom", code: "SW 7083", hex: "#443E40" },
  { name: "Arcade White", code: "SW 7100", hex: "#F3EEE7" },
  { name: "Futon", code: "SW 7101", hex: "#EDE6DB" },
  { name: "White Flour", code: "SW 7102", hex: "#F4EFE5" },
  { name: "Whitetail", code: "SW 7103", hex: "#F4EFE4" },
  { name: "Cotton White", code: "SW 7104", hex: "#F7EFE3" },
  { name: "Paperwhite", code: "SW 7105", hex: "#F7EFDE" },
  { name: "Honied White", code: "SW 7106", hex: "#F8EEDB" },
  { name: "Threshold Taupe", code: "SW 7501", hex: "#AC9A8A" },
  { name: "Dry Dock", code: "SW 7502", hex: "#A18D7D" },
  { name: "Sticks & Stones", code: "SW 7503", hex: "#A49689" },
  { name: "Keystone Gray", code: "SW 7504", hex: "#9E9284" },
  { name: "Manor House", code: "SW 7505", hex: "#665D57" },
  { name: "Loggia", code: "SW 7506", hex: "#C4B7A5" },
  { name: "Stone Lion", code: "SW 7507", hex: "#B3A491" },
  { name: "Tavern Taupe", code: "SW 7508", hex: "#9C8A79" },
  { name: "Tiki Hut", code: "SW 7509", hex: "#826F5E" },
  { name: "Chateau Brown", code: "SW 7510", hex: "#5B4B44" },
  { name: "Bungalow Beige", code: "SW 7511", hex: "#CDBFB0" },
  { name: "Pavilion Beige", code: "SW 7512", hex: "#C5B6A4" },
  { name: "Sanderling", code: "SW 7513", hex: "#A79582" },
  { name: "Foothills", code: "SW 7514", hex: "#827466" },
  { name: "Homestead Brown", code: "SW 7515", hex: "#6E5F53" },
  { name: "Kestrel White", code: "SW 7516", hex: "#E0D6C8" },
  { name: "Rivers Edge", code: "SW 7517", hex: "#DBCEBD" },
  { name: "Beach House", code: "SW 7518", hex: "#C9B29C" },
  { name: "Mexican Sand", code: "SW 7519", hex: "#AF9781" },
  { name: "Plantation Shutters", code: "SW 7520", hex: "#6A5143" },
  { name: "Dormer Brown", code: "SW 7521", hex: "#AD947C" },
  { name: "Meadowlark", code: "SW 7522", hex: "#9F8267" },
  { name: "Burnished Brandy", code: "SW 7523", hex: "#7C5C43" },
  { name: "Dhurrie Beige", code: "SW 7524", hex: "#CABAA8" },
  { name: "Tree Branch", code: "SW 7525", hex: "#8A7362" },
  { name: "Maison Blanche", code: "SW 7526", hex: "#DFD2BF" },
  { name: "Nantucket Dune", code: "SW 7527", hex: "#D0BFAA" },
  { name: "Windsor Greige", code: "SW 7528", hex: "#C4B49C" },
  { name: "Sand Beach", code: "SW 7529", hex: "#D4C5AD" },
  { name: "Barcelona Beige", code: "SW 7530", hex: "#C4B39C" },
  { name: "Canvas Tan", code: "SW 7531", hex: "#DCD1BF" },
  { name: "Urban Putty", code: "SW 7532", hex: "#CFC0AB" },
  { name: "Khaki Shade", code: "SW 7533", hex: "#C0AF97" },
  { name: "Outerbanks", code: "SW 7534", hex: "#B7A48B" },
  { name: "Sandy Ridge", code: "SW 7535", hex: "#A18E77" },
  { name: "Bittersweet Stem", code: "SW 7536", hex: "#CBB49A" },
  { name: "Irish Cream", code: "SW 7537", hex: "#E3D2B8" },
  { name: "Tamarind", code: "SW 7538", hex: "#C0A588" },
  { name: "Cork Wedge", code: "SW 7539", hex: "#C1A98A" },
  { name: "Artisan Tan", code: "SW 7540", hex: "#B09879" },
  { name: "Grecian Ivory", code: "SW 7541", hex: "#D8CFBE" },
  { name: "Naturel", code: "SW 7542", hex: "#CBC0AD" },
  { name: "Avenue Tan", code: "SW 7543", hex: "#BCB099" },
  { name: "Fenland", code: "SW 7544", hex: "#AC9D83" },
  { name: "Pier", code: "SW 7545", hex: "#63523D" },
  { name: "Prairie Grass", code: "SW 7546", hex: "#B1A38E" },
  { name: "Sandbar", code: "SW 7547", hex: "#CBBFAD" },
  { name: "Portico", code: "SW 7548", hex: "#BBAB95" },
  { name: "Studio Taupe", code: "SW 7549", hex: "#AD9C85" },
  { name: "Resort Tan", code: "SW 7550", hex: "#907D66" },
  { name: "Greek Villa", code: "SW 7551", hex: "#F0ECE2" },
  { name: "Bauhaus Buff", code: "SW 7552", hex: "#E7DBCC" },
  { name: "Fragile Beauty", code: "SW 7553", hex: "#E7D7C6" },
  { name: "Steamed Milk", code: "SW 7554", hex: "#ECE1D1" },
  { name: "Patience", code: "SW 7555", hex: "#E2D3BF" },
  { name: "Cr\u00e8me", code: "SW 7556", hex: "#F4E8D2" },
  { name: "Summer White", code: "SW 7557", hex: "#F4E9D6" },
  { name: "Medici Ivory", code: "SW 7558", hex: "#F3E9D7" },
  { name: "D\u00e9cor White", code: "SW 7559", hex: "#F2E5CF" },
  { name: "Impressive Ivory", code: "SW 7560", hex: "#F4DEC3" },
  { name: "Lemon Meringue", code: "SW 7561", hex: "#F5EACC" },
  { name: "Roman Column", code: "SW 7562", hex: "#F6F0E2" },
  { name: "Restful White", code: "SW 7563", hex: "#EEE8D7" },
  { name: "Polar Bear", code: "SW 7564", hex: "#E8DFCA" },
  { name: "Oyster Bar", code: "SW 7565", hex: "#DBD0BB" },
  { name: "Westhighland White", code: "SW 7566", hex: "#F3EEE3" },
  { name: "Natural Tan", code: "SW 7567", hex: "#DCD2C3" },
  { name: "Neutral Ground", code: "SW 7568", hex: "#E2DACA" },
  { name: "Stucco", code: "SW 7569", hex: "#DCCFBA" },
  { name: "Egret White", code: "SW 7570", hex: "#DFD9CF" },
  { name: "Casa Blanca", code: "SW 7571", hex: "#EDE1CE" },
  { name: "Lotus Pod", code: "SW 7572", hex: "#E7D7C2" },
  { name: "Eaglet Beige", code: "SW 7573", hex: "#E9D9C0" },
  { name: "Echelon Ecru", code: "SW 7574", hex: "#E7D8BE" },
  { name: "Chopsticks", code: "SW 7575", hex: "#E0D1B8" },
  { name: "Blackberry", code: "SW 7577", hex: "#533640" },
  { name: "Borscht", code: "SW 7578", hex: "#72353D" },
  { name: "Alaea", code: "SW 7579", hex: "#81585B" },
  { name: "Carnelian", code: "SW 7580", hex: "#573E3E" },
  { name: "Salute", code: "SW 7582", hex: "#803532" },
  { name: "Wild Currant", code: "SW 7583", hex: "#7C3239" },
  { name: "Red Theatre", code: "SW 7584", hex: "#6E3637" },
  { name: "Sun Dried Tomato", code: "SW 7585", hex: "#692B2B" },
  { name: "Stolen Kiss", code: "SW 7586", hex: "#813235" },
  { name: "Antique Red", code: "SW 7587", hex: "#9F4442" },
  { name: "Show Stopper", code: "SW 7588", hex: "#A42E37" },
  { name: "Habanero Chile", code: "SW 7589", hex: "#B8473D" },
  { name: "Red Barn", code: "SW 7591", hex: "#7C453D" },
  { name: "Crabby Apple", code: "SW 7592", hex: "#753531" },
  { name: "Rustic Red", code: "SW 7593", hex: "#703229" },
  { name: "Carriage Door", code: "SW 7594", hex: "#6E423E" },
  { name: "Sommelier", code: "SW 7595", hex: "#5D3736" },
  { name: "Only Natural", code: "SW 7596", hex: "#E2D3C4" },
  { name: "Sierra Redwood", code: "SW 7598", hex: "#924E3C" },
  { name: "Brick Paver", code: "SW 7599", hex: "#93402F" },
  { name: "Bolero", code: "SW 7600", hex: "#903934" },
  { name: "Dockside Blue", code: "SW 7601", hex: "#A0B3BC" },
  { name: "Indigo Batik", code: "SW 7602", hex: "#3E5063" },
  { name: "Poolhouse", code: "SW 7603", hex: "#8095A0" },
  { name: "Smoky Blue", code: "SW 7604", hex: "#596E79" },
  { name: "Gale Force", code: "SW 7605", hex: "#35454E" },
  { name: "Blue Cruise", code: "SW 7606", hex: "#6591A8" },
  { name: "Santorini Blue", code: "SW 7607", hex: "#416D83" },
  { name: "Adrift", code: "SW 7608", hex: "#87AAB9" },
  { name: "Georgian Revival Blue", code: "SW 7609", hex: "#5B8D9F" },
  { name: "Turkish Tile", code: "SW 7610", hex: "#3E758A" },
  { name: "Tranquil Aqua", code: "SW 7611", hex: "#7C9AA0" },
  { name: "Mountain Stream", code: "SW 7612", hex: "#679199" },
  { name: "Aqua-Sphere", code: "SW 7613", hex: "#9CB0B3" },
  { name: "St. Bart's", code: "SW 7614", hex: "#577C88" },
  { name: "Sea Serpent", code: "SW 7615", hex: "#3E4B54" },
  { name: "Breezy", code: "SW 7616", hex: "#A0AEAF" },
  { name: "Mediterranean", code: "SW 7617", hex: "#60797D" },
  { name: "Deep Sea Dive", code: "SW 7618", hex: "#376167" },
  { name: "Labradorite", code: "SW 7619", hex: "#657B83" },
  { name: "Seaworthy", code: "SW 7620", hex: "#314D58" },
  { name: "Silvermist", code: "SW 7621", hex: "#B0B8B2" },
  { name: "Homburg Gray", code: "SW 7622", hex: "#666D69" },
  { name: "Cascades", code: "SW 7623", hex: "#273E3E" },
  { name: "Slate Tile", code: "SW 7624", hex: "#606E74" },
  { name: "Mount Etna", code: "SW 7625", hex: "#3D484C" },
  { name: "Zurich White", code: "SW 7626", hex: "#E6E1D9" },
  { name: "White Heron", code: "SW 7627", hex: "#E7E1D7" },
  { name: "Windfresh White", code: "SW 7628", hex: "#DED8CF" },
  { name: "Grapy", code: "SW 7629", hex: "#786E70" },
  { name: "Raisin", code: "SW 7630", hex: "#392B2D" },
  { name: "City Loft", code: "SW 7631", hex: "#DFDAD1" },
  { name: "Modern Gray", code: "SW 7632", hex: "#D6CEC3" },
  { name: "Taupe Tone", code: "SW 7633", hex: "#ADA090" },
  { name: "Pediment", code: "SW 7634", hex: "#D3CCC4" },
  { name: "Palisade", code: "SW 7635", hex: "#AA9E95" },
  { name: "Origami White", code: "SW 7636", hex: "#E5E2DA" },
  { name: "Oyster White", code: "SW 7637", hex: "#E2DDD0" },
  { name: "Jogging Path", code: "SW 7638", hex: "#C0B9A9" },
  { name: "Ethereal Mood", code: "SW 7639", hex: "#AEA594" },
  { name: "Fawn Brindle", code: "SW 7640", hex: "#A7A094" },
  { name: "Colonnade Gray", code: "SW 7641", hex: "#C6C0B6" },
  { name: "Pavestone", code: "SW 7642", hex: "#A0998F" },
  { name: "Pussywillow", code: "SW 7643", hex: "#B2ADA4" },
  { name: "Gateway Gray", code: "SW 7644", hex: "#B2AC9C" },
  { name: "Thunder Gray", code: "SW 7645", hex: "#57534C" },
  { name: "First Star", code: "SW 7646", hex: "#DAD9D4" },
  { name: "Crushed Ice", code: "SW 7647", hex: "#D6D3CC" },
  { name: "Big Chill", code: "SW 7648", hex: "#D0CEC9" },
  { name: "Silverplate", code: "SW 7649", hex: "#C2C0BA" },
  { name: "Ellie Gray", code: "SW 7650", hex: "#AAA9A4" },
  { name: "Front Porch", code: "SW 7651", hex: "#CCCCC5" },
  { name: "Mineral Deposit", code: "SW 7652", hex: "#ABB0AC" },
  { name: "Silverpointe", code: "SW 7653", hex: "#D1D2CB" },
  { name: "Lattice", code: "SW 7654", hex: "#CECEC6" },
  { name: "Stamped Concrete", code: "SW 7655", hex: "#A0A09A" },
  { name: "Rhinestone", code: "SW 7656", hex: "#DEE0DE" },
  { name: "Tinsmith", code: "SW 7657", hex: "#C5C8C4" },
  { name: "Gray Clouds", code: "SW 7658", hex: "#B7B7B2" },
  { name: "Gris", code: "SW 7659", hex: "#A5A9A8" },
  { name: "Earl Grey", code: "SW 7660", hex: "#969A96" },
  { name: "Reflection", code: "SW 7661", hex: "#D3D5D3" },
  { name: "Evening Shadow", code: "SW 7662", hex: "#C9CCCD" },
  { name: "Monorail Silver", code: "SW 7663", hex: "#B8BCBB" },
  { name: "Steely Gray", code: "SW 7664", hex: "#90979B" },
  { name: "Wall Street", code: "SW 7665", hex: "#656D73" },
  { name: "Fleur de Sel", code: "SW 7666", hex: "#DCDDD8" },
  { name: "Zircon", code: "SW 7667", hex: "#CAC9C6" },
  { name: "March Wind", code: "SW 7668", hex: "#BAB9B6" },
  { name: "Summit Gray", code: "SW 7669", hex: "#959491" },
  { name: "Gray Shingle", code: "SW 7670", hex: "#949392" },
  { name: "On the Rocks", code: "SW 7671", hex: "#D0CEC8" },
  { name: "Knitting Needles", code: "SW 7672", hex: "#C3C1BC" },
  { name: "Pewter Cast", code: "SW 7673", hex: "#9B9893" },
  { name: "Peppercorn", code: "SW 7674", hex: "#585858" },
  { name: "Sealskin", code: "SW 7675", hex: "#48423C" },
  { name: "Paper Lantern", code: "SW 7676", hex: "#F2E0C4" },
  { name: "Gold Vessel", code: "SW 7677", hex: "#EABA8A" },
  { name: "Cottage Cream", code: "SW 7678", hex: "#EDDBBD" },
  { name: "Golden Gate", code: "SW 7679", hex: "#D9AD7F" },
  { name: "Lanyard", code: "SW 7680", hex: "#C09972" },
  { name: "Tea Light", code: "SW 7681", hex: "#F8E4C2" },
  { name: "Bee's Wax", code: "SW 7682", hex: "#EABF86" },
  { name: "Buff", code: "SW 7683", hex: "#F1DFC1" },
  { name: "Concord Buff", code: "SW 7684", hex: "#EDD6B1" },
  { name: "White Raisin", code: "SW 7685", hex: "#E5C28B" },
  { name: "Hinoki", code: "SW 7686", hex: "#F8DDB7" },
  { name: "August Moon", code: "SW 7687", hex: "#E7C7A0" },
  { name: "Sundew", code: "SW 7688", hex: "#E1CDAE" },
  { name: "Row House Tan", code: "SW 7689", hex: "#D2BB9D" },
  { name: "Townhall Tan", code: "SW 7690", hex: "#C3AA8C" },
  { name: "Pale Yellow", code: "SW 7691", hex: "#E3C9A1" },
  { name: "Cupola Yellow", code: "SW 7692", hex: "#DCBC8E" },
  { name: "Stonebriar", code: "SW 7693", hex: "#CBA97E" },
  { name: "Dromedary Camel", code: "SW 7694", hex: "#CAAD87" },
  { name: "Mesa Tan", code: "SW 7695", hex: "#BD9C77" },
  { name: "Toasted Pine Nut", code: "SW 7696", hex: "#DCC6A6" },
  { name: "Safari", code: "SW 7697", hex: "#CCB18B" },
  { name: "Straw Harvest", code: "SW 7698", hex: "#DBC8A2" },
  { name: "Rustic City", code: "SW 7699", hex: "#BA9A67" },
  { name: "Olde World Gold", code: "SW 7700", hex: "#8F6C3E" },
  { name: "Cavern Clay", code: "SW 7701", hex: "#AC6B53" },
  { name: "Spiced Cider", code: "SW 7702", hex: "#B0785C" },
  { name: "Earthen Jug", code: "SW 7703", hex: "#A85E39" },
  { name: "Tower Tan", code: "SW 7704", hex: "#D5B59B" },
  { name: "Wheat Penny", code: "SW 7705", hex: "#976B53" },
  { name: "Copper Wire", code: "SW 7707", hex: "#C67B57" },
  { name: "Copper Pot", code: "SW 7709", hex: "#B16A37" },
  { name: "Brandywine", code: "SW 7710", hex: "#A56C4A" },
  { name: "Pueblo", code: "SW 7711", hex: "#E6D0BD" },
  { name: "Townhouse Tan", code: "SW 7712", hex: "#DFC8B5" },
  { name: "Tawny Tan", code: "SW 7713", hex: "#CCB299" },
  { name: "Oak Barrel", code: "SW 7714", hex: "#BFA287" },
  { name: "Pottery Urn", code: "SW 7715", hex: "#AA866E" },
  { name: "Croissant", code: "SW 7716", hex: "#DBC5A7" },
  { name: "Ligonier Tan", code: "SW 7717", hex: "#D2B18F" },
  { name: "Oak Creek", code: "SW 7718", hex: "#BB8D6B" },
  { name: "Fresco Cream", code: "SW 7719", hex: "#D8C4AE" },
  { name: "Deer Valley", code: "SW 7720", hex: "#C7A485" },
  { name: "Crescent Cream", code: "SW 7721", hex: "#EDD1B1" },
  { name: "Travertine", code: "SW 7722", hex: "#ECD3B3" },
  { name: "Colony Buff", code: "SW 7723", hex: "#DDC6AB" },
  { name: "Canoe", code: "SW 7724", hex: "#B7987B" },
  { name: "Yearling", code: "SW 7725", hex: "#AD896A" },
  { name: "Lemon Verbena", code: "SW 7726", hex: "#9D986F" },
  { name: "Koi Pond", code: "SW 7727", hex: "#B9B292" },
  { name: "Green Sprout", code: "SW 7728", hex: "#A29F80" },
  { name: "Edamame", code: "SW 7729", hex: "#827C5A" },
  { name: "Forestwood", code: "SW 7730", hex: "#4D5346" },
  { name: "San Antonio Sage", code: "SW 7731", hex: "#A69474" },
  { name: "Lemongrass", code: "SW 7732", hex: "#C8BD98" },
  { name: "Bamboo Shoot", code: "SW 7733", hex: "#B3A479" },
  { name: "Olive Grove", code: "SW 7734", hex: "#857C5D" },
  { name: "Palm Leaf", code: "SW 7735", hex: "#635936" },
  { name: "Garden Sage", code: "SW 7736", hex: "#B1A584" },
  { name: "Meadow Trail", code: "SW 7737", hex: "#8D8168" },
  { name: "Cargo Pants", code: "SW 7738", hex: "#CDC4AE" },
  { name: "Herbal Wash", code: "SW 7739", hex: "#A49B82" },
  { name: "Messenger Bag", code: "SW 7740", hex: "#7D745E" },
  { name: "Willow Tree", code: "SW 7741", hex: "#AAAD9C" },
  { name: "Agate Green", code: "SW 7742", hex: "#8EA486" },
  { name: "Mountain Road", code: "SW 7743", hex: "#868578" },
  { name: "Zeus", code: "SW 7744", hex: "#99907E" },
  { name: "Muddled Basil", code: "SW 7745", hex: "#5A5243" },
  { name: "Rushing River", code: "SW 7746", hex: "#A19C8F" },
  { name: "Recycled Glass", code: "SW 7747", hex: "#BDC0A0" },
  { name: "Green Earth", code: "SW 7748", hex: "#9A9883" },
  { name: "Laurel Woods", code: "SW 7749", hex: "#44493D" },
  { name: "Olympic Range", code: "SW 7750", hex: "#424C44" },
  { name: "High Reflective White", code: "SW 7757", hex: "#F7F7F1" },
  { name: "Shell White", code: "SW 8917", hex: "#F0EBE0" },
  { name: "Audrey's Blush", code: "SW 9001", hex: "#AE8087" },
  { name: "Carley's Rose", code: "SW 9002", hex: "#A87376" },
  { name: "Rita's Rouge", code: "SW 9003", hex: "#BA7176" },
  { name: "Coral Rose", code: "SW 9004", hex: "#C37F7A" },
  { name: "Coral Clay", code: "SW 9005", hex: "#BF796E" },
  { name: "Rojo Dust", code: "SW 9006", hex: "#B57466" },
  { name: "Mel\u00f3n Meloso", code: "SW 9007", hex: "#F2B88C" },
  { name: "Bellini Fizz", code: "SW 9008", hex: "#F5C78E" },
  { name: "Subdued Sienna", code: "SW 9009", hex: "#CC896C" },
  { name: "Windswept Canyon", code: "SW 9010", hex: "#DBA480" },
  { name: "Sun Bleached Ochre", code: "SW 9011", hex: "#E3AB7B" },
  { name: "Polvo de Oro", code: "SW 9012", hex: "#E8B87F" },
  { name: "Olden Amber", code: "SW 9013", hex: "#EEB76B" },
  { name: "Pollen Powder", code: "SW 9014", hex: "#FBD187" },
  { name: "They call it Mellow", code: "SW 9015", hex: "#FBE4B3" },
  { name: "La Luna Amarilla", code: "SW 9016", hex: "#FDDFA0" },
  { name: "Sunny Veranda", code: "SW 9017", hex: "#FEDF94" },
  { name: "Honey Bees", code: "SW 9018", hex: "#FBD682" },
  { name: "Golden Plumeria", code: "SW 9019", hex: "#FBD073" },
  { name: "Rayo de Sol", code: "SW 9020", hex: "#F4C454" },
  { name: "Naples Yellow", code: "SW 9021", hex: "#F6D58F" },
  { name: "Yellow Bird", code: "SW 9022", hex: "#F1CD7B" },
  { name: "Dakota Wheat", code: "SW 9023", hex: "#E1BD8E" },
  { name: "Vintage Gold", code: "SW 9024", hex: "#CBA576" },
  { name: "Coriander Powder", code: "SW 9025", hex: "#BA9C75" },
  { name: "Tarnished Trumpet", code: "SW 9026", hex: "#D5B176" },
  { name: "Pale Moss", code: "SW 9027", hex: "#DCC797" },
  { name: "Dusted Olive", code: "SW 9028", hex: "#BEA775" },
  { name: "Cool Avocado", code: "SW 9029", hex: "#C4B47D" },
  { name: "Lim\u00f3n Fresco", code: "SW 9030", hex: "#CEBC55" },
  { name: "Primavera", code: "SW 9031", hex: "#D2D083" },
  { name: "Stay in Lime", code: "SW 9032", hex: "#9FAC5C" },
  { name: "Oh Pistachio", code: "SW 9033", hex: "#ABCA99" },
  { name: "Seawashed Glass", code: "SW 9034", hex: "#A9C095" },
  { name: "Frosted Emerald", code: "SW 9035", hex: "#78B185" },
  { name: "Retro Mint", code: "SW 9036", hex: "#9FCDB1" },
  { name: "Baby Bok Choy", code: "SW 9037", hex: "#BBB98A" },
  { name: "Cucuzza Verde", code: "SW 9038", hex: "#9BA373" },
  { name: "Broccoflower", code: "SW 9039", hex: "#8FA277" },
  { name: "Reseda Green", code: "SW 9040", hex: "#75946B" },
  { name: "Parisian Patina", code: "SW 9041", hex: "#7D9B89" },
  { name: "Verdigreen", code: "SW 9042", hex: "#81A595" },
  { name: "Aquastone", code: "SW 9043", hex: "#89C6B7" },
  { name: "Little Blue Box", code: "SW 9044", hex: "#8AC5BA" },
  { name: "Bora Bora Shore", code: "SW 9045", hex: "#92D0D0" },
  { name: "Gentle Aquamarine", code: "SW 9046", hex: "#97CBD2" },
  { name: "After the Rain", code: "SW 9047", hex: "#8BC4D1" },
  { name: "Surfin'", code: "SW 9048", hex: "#73C0D2" },
  { name: "Sky Fall", code: "SW 9049", hex: "#89C6DF" },
  { name: "Vintage Vessel", code: "SW 9050", hex: "#94B2A6" },
  { name: "Aquaverde", code: "SW 9051", hex: "#A3C0BD" },
  { name: "Blithe Blue", code: "SW 9052", hex: "#90BDBD" },
  { name: "Agua Fr\u00eda", code: "SW 9053", hex: "#9FC5CC" },
  { name: "Little Boy Blu", code: "SW 9054", hex: "#C7D8DB" },
  { name: "Billowy Breeze", code: "SW 9055", hex: "#AFC7CD" },
  { name: "French Moire", code: "SW 9056", hex: "#9FBBC3" },
  { name: "Aquitaine", code: "SW 9057", hex: "#88ABB4" },
  { name: "Secret Cove", code: "SW 9058", hex: "#68909D" },
  { name: "Silken Peacock", code: "SW 9059", hex: "#427584" },
  { name: "Connor's Lakefront", code: "SW 9060", hex: "#175A6C" },
  { name: "Rest Assured", code: "SW 9061", hex: "#9BBFC9" },
  { name: "Bluebird Feather", code: "SW 9062", hex: "#6F9DB3" },
  { name: "Porch Ceiling", code: "SW 9063", hex: "#9BC8DE" },
  { name: "Bluesy Note", code: "SW 9064", hex: "#7C9AB5" },
  { name: "Perfect Periwinkle", code: "SW 9065", hex: "#6487B0" },
  { name: "Agapanthus", code: "SW 9066", hex: "#BBC5DE" },
  { name: "Forever Lilac", code: "SW 9067", hex: "#AFA5C7" },
  { name: "Berry Frapp\u00e9", code: "SW 9068", hex: "#B3A1C6" },
  { name: "Veri Berri", code: "SW 9069", hex: "#937496" },
  { name: "Baby Blue Eyes", code: "SW 9070", hex: "#83A2B4" },
  { name: "Dyer's Woad", code: "SW 9071", hex: "#7B99B0" },
  { name: "Dried Lavender", code: "SW 9072", hex: "#8595AA" },
  { name: "Dusty Heather", code: "SW 9073", hex: "#8990A3" },
  { name: "Gentle Grape", code: "SW 9074", hex: "#908A9B" },
  { name: "Berry Cream", code: "SW 9075", hex: "#9A8CA2" },
  { name: "Ruby Violet", code: "SW 9076", hex: "#9B7E8B" },
  { name: "Rosaline Pearl", code: "SW 9077", hex: "#A38887" },
  { name: "Cocoa Berry", code: "SW 9078", hex: "#A08882" },
  { name: "Velvety Chestnut", code: "SW 9079", hex: "#A2877D" },
  { name: "Hushed Auburn", code: "SW 9080", hex: "#A8857A" },
  { name: "Redend Point", code: "SW 9081", hex: "#AE8E7E" },
  { name: "Chocolate Powder", code: "SW 9082", hex: "#A58C7B" },
  { name: "Dusted Truffle", code: "SW 9083", hex: "#9C8373" },
  { name: "Cocoa Whip", code: "SW 9084", hex: "#A08E7E" },
  { name: "Touch of Sand", code: "SW 9085", hex: "#D5C7BA" },
  { name: "Cool Beige", code: "SW 9086", hex: "#C6B5A7" },
  { name: "Smoky Beige", code: "SW 9087", hex: "#B9A796" },
  { name: "Utaupeia", code: "SW 9088", hex: "#A58F7B" },
  { name: "Llama Wool", code: "SW 9089", hex: "#917864" },
  { name: "Cara\u00efbe", code: "SW 9090", hex: "#785F4C" },
  { name: "Half-Caff", code: "SW 9091", hex: "#604C3D" },
  { name: "Iced Mocha", code: "SW 9092", hex: "#A3846C" },
  { name: "Nearly Brown", code: "SW 9093", hex: "#A88E76" },
  { name: "Playa Arenosa", code: "SW 9094", hex: "#DCC7B3" },
  { name: "Ginger Root", code: "SW 9095", hex: "#D2B79E" },
  { name: "Beige Intenso", code: "SW 9096", hex: "#C5A88D" },
  { name: "Soft Fawn", code: "SW 9097", hex: "#B59778" },
  { name: "Baked Cookie", code: "SW 9098", hex: "#89674A" },
  { name: "Saddle Up", code: "SW 9099", hex: "#725237" },
  { name: "Umber Rust", code: "SW 9100", hex: "#765138" },
  { name: "Tres Naturale", code: "SW 9101", hex: "#DCC7AD" },
  { name: "Quinoa", code: "SW 9102", hex: "#CFB597" },
  { name: "Farro", code: "SW 9103", hex: "#C1A485" },
  { name: "Woven Wicker", code: "SW 9104", hex: "#B99974" },
  { name: "Almond Roca", code: "SW 9105", hex: "#A78361" },
  { name: "El Caramelo", code: "SW 9106", hex: "#946E48" },
  { name: "\u00dcber Umber", code: "SW 9107", hex: "#7B5838" },
  { name: "Double Latte", code: "SW 9108", hex: "#A78C71" },
  { name: "Natural Linen", code: "SW 9109", hex: "#DFD3C3" },
  { name: "Malabar", code: "SW 9110", hex: "#CFBEA9" },
  { name: "Antler Velvet", code: "SW 9111", hex: "#C0AD96" },
  { name: "Song Thrush", code: "SW 9112", hex: "#AF987F" },
  { name: "Mudslide", code: "SW 9113", hex: "#A08568" },
  { name: "Fallen Leaves", code: "SW 9114", hex: "#8F7659" },
  { name: "Cowboy Boots", code: "SW 9115", hex: "#695239" },
  { name: "Serengeti Grass", code: "SW 9116", hex: "#AB9579" },
  { name: "Urban Jungle", code: "SW 9117", hex: "#A4947E" },
  { name: "Tarnished Treasure", code: "SW 9118", hex: "#B9A47E" },
  { name: "Dirty Martini", code: "SW 9119", hex: "#DDD0B6" },
  { name: "Tumblin' Tumbleweed", code: "SW 9120", hex: "#CDBB9C" },
  { name: "Sawgrass Basket", code: "SW 9121", hex: "#C3B090" },
  { name: "Dried Edamame", code: "SW 9122", hex: "#B19F80" },
  { name: "Barro Verde", code: "SW 9123", hex: "#9F8E71" },
  { name: "Verde Marr\u00f3n", code: "SW 9124", hex: "#877459" },
  { name: "Oliva Oscuro", code: "SW 9125", hex: "#665439" },
  { name: "Honed Soapstone", code: "SW 9126", hex: "#9D9887" },
  { name: "At Ease Soldier", code: "SW 9127", hex: "#9E9985" },
  { name: "Green Onyx", code: "SW 9128", hex: "#989A82" },
  { name: "Jade Dragon", code: "SW 9129", hex: "#909886" },
  { name: "Evergreen Fog", code: "SW 9130", hex: "#95978A" },
  { name: "Cornwall Slate", code: "SW 9131", hex: "#949488" },
  { name: "Acacia Haze", code: "SW 9132", hex: "#969C92" },
  { name: "Jasper Stone", code: "SW 9133", hex: "#8D9E97" },
  { name: "Delft", code: "SW 9134", hex: "#8B9FA0" },
  { name: "Whirlpool", code: "SW 9135", hex: "#80969D" },
  { name: "Lullaby", code: "SW 9136", hex: "#CBD4D4" },
  { name: "Niebla Azul", code: "SW 9137", hex: "#B6C3C4" },
  { name: "Stardew", code: "SW 9138", hex: "#A6B2B5" },
  { name: "Debonair", code: "SW 9139", hex: "#90A0A6" },
  { name: "Blustery Sky", code: "SW 9140", hex: "#6F848C" },
  { name: "Waterloo", code: "SW 9141", hex: "#536872" },
  { name: "Moscow Midnight", code: "SW 9142", hex: "#204652" },
  { name: "Cadet", code: "SW 9143", hex: "#91999C" },
  { name: "Moonmist", code: "SW 9144", hex: "#C9D9E0" },
  { name: "Sleepy Hollow", code: "SW 9145", hex: "#B7C9D1" },
  { name: "Faded Flaxflower", code: "SW 9146", hex: "#9EB4C0" },
  { name: "Favorite Jeans", code: "SW 9147", hex: "#8AA3B1" },
  { name: "Smoky Azurite", code: "SW 9148", hex: "#708D9E" },
  { name: "Inky Blue", code: "SW 9149", hex: "#4E7287" },
  { name: "Endless Sea", code: "SW 9150", hex: "#32586E" },
  { name: "Daphne", code: "SW 9151", hex: "#899CAA" },
  { name: "Let it Rain", code: "SW 9152", hex: "#979FA5" },
  { name: "Moonlit Orchid", code: "SW 9153", hex: "#949194" },
  { name: "Perle Noir", code: "SW 9154", hex: "#4F4D51" },
  { name: "Slate Violet", code: "SW 9155", hex: "#989192" },
  { name: "Gris Morado", code: "SW 9156", hex: "#8F8A91" },
  { name: "Autumn Orchid", code: "SW 9157", hex: "#9D9093" },
  { name: "Coquina", code: "SW 9158", hex: "#9D8D8E" },
  { name: "Auger Shell", code: "SW 9159", hex: "#9F9291" },
  { name: "Armadillo", code: "SW 9160", hex: "#9E9089" },
  { name: "Dustblu", code: "SW 9161", hex: "#959BA0" },
  { name: "African Gray", code: "SW 9162", hex: "#939899" },
  { name: "Tin Lizzie", code: "SW 9163", hex: "#939591" },
  { name: "Illusive Green", code: "SW 9164", hex: "#92948D" },
  { name: "Gossamer Veil", code: "SW 9165", hex: "#D3CEC4" },
  { name: "Drift of Mist", code: "SW 9166", hex: "#DCD8D0" },
  { name: "Polished Concrete", code: "SW 9167", hex: "#9E9793" },
  { name: "Elephant Ear", code: "SW 9168", hex: "#988F85" },
  { name: "Chatura Gray", code: "SW 9169", hex: "#A09287" },
  { name: "Acier", code: "SW 9170", hex: "#9E9991" },
  { name: "Felted Wool", code: "SW 9171", hex: "#979083" },
  { name: "Studio Clay", code: "SW 9172", hex: "#958D7F" },
  { name: "Shiitake", code: "SW 9173", hex: "#C8BCAB" },
  { name: "Moth Wing", code: "SW 9174", hex: "#A0907F" },
  { name: "Deep Forest Brown", code: "SW 9175", hex: "#393437" },
  { name: "Dress Blues", code: "SW 9176", hex: "#2B4360" },
  { name: "Salty Dog", code: "SW 9177", hex: "#234058" },
  { name: "In the Navy", code: "SW 9178", hex: "#283849" },
  { name: "Anchors Aweigh", code: "SW 9179", hex: "#2B3441" },
  { name: "Aged White", code: "SW 9180", hex: "#E8DECD" },
  { name: "Rojo Marr\u00f3n", code: "SW 9182", hex: "#4B3029" },
  { name: "Dark Clove", code: "SW 9183", hex: "#4C3D31" },
  { name: "Foxhall Green", code: "SW 9184", hex: "#454B40" },
  { name: "Marea Baja", code: "SW 9185", hex: "#2E5464" },
  { name: "Caramelized", code: "SW 9186", hex: "#C29871" }
];

// Featured group shown first (Sherwin-Williams Top 50).
window.RTA_RECENT = [
  { name: "Pure White", code: "SW 7005", hex: "#EDECE6" },
  { name: "Agreeable Gray", code: "SW 7029", hex: "#D1CBC1" },
  { name: "Snowbound", code: "SW 7004", hex: "#EDEAE5" },
  { name: "Alabaster", code: "SW 7008", hex: "#EDEAE0" },
  { name: "Repose Gray", code: "SW 7015", hex: "#CCC9C0" },
  { name: "City Loft", code: "SW 7631", hex: "#DFDAD1" },
  { name: "Dover White", code: "SW 6385", hex: "#F0EADC" },
  { name: "Accessible Beige", code: "SW 7036", hex: "#D1C7B8" },
  { name: "Greek Villa", code: "SW 7551", hex: "#F0ECE2" },
  { name: "Drift of Mist", code: "SW 9166", hex: "#DCD8D0" },
  { name: "Eider White", code: "SW 7014", hex: "#E2DED8" },
  { name: "First Star", code: "SW 7646", hex: "#DAD9D4" },
  { name: "Worldly Gray", code: "SW 7043", hex: "#CEC6BB" },
  { name: "Crushed Ice", code: "SW 7647", hex: "#D6D3CC" },
  { name: "Shoji White", code: "SW 7042", hex: "#E6DFD3" },
  { name: "Ceiling Bright White", code: "SW 7007", hex: "#E9EBE7" },
  { name: "Shell White", code: "SW 8917", hex: "#F0EBE0" },
  { name: "Gossamer Veil", code: "SW 9165", hex: "#D3CEC4" },
  { name: "Aesthetic White", code: "SW 7035", hex: "#E3DDD3" },
  { name: "Origami White", code: "SW 7636", hex: "#E5E2DA" },
  { name: "Pearly White", code: "SW 7009", hex: "#E8E3D9" },
  { name: "On the Rocks", code: "SW 7671", hex: "#D0CEC8" },
  { name: "Tricorn Black", code: "SW 6258", hex: "#2F2F30" },
  { name: "Passive", code: "SW 7064", hex: "#CBCCC9" },
  { name: "Mindful Gray", code: "SW 7016", hex: "#BCB7AD" },
  { name: "Natural Choice", code: "SW 7011", hex: "#E3DED0" },
  { name: "Light French Gray", code: "SW 0055", hex: "#C2C0BB" },
  { name: "Creamy", code: "SW 7012", hex: "#EFE8DB" },
  { name: "Incredible White", code: "SW 7028", hex: "#E3DED7" },
  { name: "Egret White", code: "SW 7570", hex: "#DFD9CF" },
  { name: "Antique White", code: "SW 6119", hex: "#E8DCC6" },
  { name: "Kilim Beige", code: "SW 6106", hex: "#D7C5AE" },
  { name: "Heron Plume", code: "SW 6070", hex: "#E5E1D8" },
  { name: "Westhighland White", code: "SW 7566", hex: "#F3EEE3" },
  { name: "Natural Linen", code: "SW 9109", hex: "#DFD3C3" },
  { name: "Anew Gray", code: "SW 7030", hex: "#BFB6AA" },
  { name: "Modern Gray", code: "SW 7632", hex: "#D6CEC3" },
  { name: "Iron Ore", code: "SW 7069", hex: "#434341" },
  { name: "Reflection", code: "SW 7661", hex: "#D3D5D3" },
  { name: "White Flour", code: "SW 7102", hex: "#F4EFE5" },
  { name: "Extra White", code: "SW 7006", hex: "#EEEFEA" },
  { name: "Ice Cube", code: "SW 6252", hex: "#E3E4E1" },
  { name: "Big Chill", code: "SW 7648", hex: "#D0CEC9" },
  { name: "Alpaca", code: "SW 7022", hex: "#CCC5BD" },
  { name: "White Duck", code: "SW 7010", hex: "#E5DFD2" },
  { name: "Amazing Gray", code: "SW 7044", hex: "#BEB5A9" },
  { name: "Sea Salt", code: "SW 6204", hex: "#CDD2CA" },
  { name: "Whitetail", code: "SW 7103", hex: "#F4EFE4" },
  { name: "Olympus White", code: "SW 6253", hex: "#D4D8D7" },
  { name: "Ivory Lace", code: "SW 7013", hex: "#ECE5D8" }
];

// Browse-by-collection groups (verified against SW collection pages).
window.SW_COLLECTIONS = {
  "Top 50 Colors": [
    { name: "Pure White", code: "SW 7005", hex: "#EDECE6" },
    { name: "Agreeable Gray", code: "SW 7029", hex: "#D1CBC1" },
    { name: "Snowbound", code: "SW 7004", hex: "#EDEAE5" },
    { name: "Alabaster", code: "SW 7008", hex: "#EDEAE0" },
    { name: "Repose Gray", code: "SW 7015", hex: "#CCC9C0" },
    { name: "City Loft", code: "SW 7631", hex: "#DFDAD1" },
    { name: "Dover White", code: "SW 6385", hex: "#F0EADC" },
    { name: "Accessible Beige", code: "SW 7036", hex: "#D1C7B8" },
    { name: "Greek Villa", code: "SW 7551", hex: "#F0ECE2" },
    { name: "Drift of Mist", code: "SW 9166", hex: "#DCD8D0" },
    { name: "Eider White", code: "SW 7014", hex: "#E2DED8" },
    { name: "First Star", code: "SW 7646", hex: "#DAD9D4" },
    { name: "Worldly Gray", code: "SW 7043", hex: "#CEC6BB" },
    { name: "Crushed Ice", code: "SW 7647", hex: "#D6D3CC" },
    { name: "Shoji White", code: "SW 7042", hex: "#E6DFD3" },
    { name: "Ceiling Bright White", code: "SW 7007", hex: "#E9EBE7" },
    { name: "Shell White", code: "SW 8917", hex: "#F0EBE0" },
    { name: "Gossamer Veil", code: "SW 9165", hex: "#D3CEC4" },
    { name: "Aesthetic White", code: "SW 7035", hex: "#E3DDD3" },
    { name: "Origami White", code: "SW 7636", hex: "#E5E2DA" },
    { name: "Pearly White", code: "SW 7009", hex: "#E8E3D9" },
    { name: "On the Rocks", code: "SW 7671", hex: "#D0CEC8" },
    { name: "Tricorn Black", code: "SW 6258", hex: "#2F2F30" },
    { name: "Passive", code: "SW 7064", hex: "#CBCCC9" },
    { name: "Mindful Gray", code: "SW 7016", hex: "#BCB7AD" },
    { name: "Natural Choice", code: "SW 7011", hex: "#E3DED0" },
    { name: "Light French Gray", code: "SW 0055", hex: "#C2C0BB" },
    { name: "Creamy", code: "SW 7012", hex: "#EFE8DB" },
    { name: "Incredible White", code: "SW 7028", hex: "#E3DED7" },
    { name: "Egret White", code: "SW 7570", hex: "#DFD9CF" },
    { name: "Antique White", code: "SW 6119", hex: "#E8DCC6" },
    { name: "Kilim Beige", code: "SW 6106", hex: "#D7C5AE" },
    { name: "Heron Plume", code: "SW 6070", hex: "#E5E1D8" },
    { name: "Westhighland White", code: "SW 7566", hex: "#F3EEE3" },
    { name: "Natural Linen", code: "SW 9109", hex: "#DFD3C3" },
    { name: "Anew Gray", code: "SW 7030", hex: "#BFB6AA" },
    { name: "Modern Gray", code: "SW 7632", hex: "#D6CEC3" },
    { name: "Iron Ore", code: "SW 7069", hex: "#434341" },
    { name: "Reflection", code: "SW 7661", hex: "#D3D5D3" },
    { name: "White Flour", code: "SW 7102", hex: "#F4EFE5" },
    { name: "Extra White", code: "SW 7006", hex: "#EEEFEA" },
    { name: "Ice Cube", code: "SW 6252", hex: "#E3E4E1" },
    { name: "Big Chill", code: "SW 7648", hex: "#D0CEC9" },
    { name: "Alpaca", code: "SW 7022", hex: "#CCC5BD" },
    { name: "White Duck", code: "SW 7010", hex: "#E5DFD2" },
    { name: "Amazing Gray", code: "SW 7044", hex: "#BEB5A9" },
    { name: "Sea Salt", code: "SW 6204", hex: "#CDD2CA" },
    { name: "Whitetail", code: "SW 7103", hex: "#F4EFE4" },
    { name: "Olympus White", code: "SW 6253", hex: "#D4D8D7" },
    { name: "Ivory Lace", code: "SW 7013", hex: "#ECE5D8" }
  ],
  "Finest Whites & Neutrals": [
    { name: "High Reflective White", code: "SW 7757", hex: "#F7F7F1" },
    { name: "Roman Column", code: "SW 7562", hex: "#F6F0E2" },
    { name: "White Flour", code: "SW 7102", hex: "#F4EFE5" },
    { name: "Whitetail", code: "SW 7103", hex: "#F4EFE4" },
    { name: "Extra White", code: "SW 7006", hex: "#EEEFEA" },
    { name: "Westhighland White", code: "SW 7566", hex: "#F3EEE3" },
    { name: "Greek Villa", code: "SW 7551", hex: "#F0ECE2" },
    { name: "Pure White", code: "SW 7005", hex: "#EDECE6" },
    { name: "Shell White", code: "SW 8917", hex: "#F0EBE0" },
    { name: "Snowbound", code: "SW 7004", hex: "#EDEAE5" },
    { name: "Ceiling Bright White", code: "SW 7007", hex: "#E9EBE7" },
    { name: "Dover White", code: "SW 6385", hex: "#F0EADC" },
    { name: "Alabaster", code: "SW 7008", hex: "#EDEAE0" },
    { name: "Marshmallow", code: "SW 7001", hex: "#EEE9E0" },
    { name: "Creamy", code: "SW 7012", hex: "#EFE8DB" },
    { name: "Downy", code: "SW 7002", hex: "#EFE8DD" },
    { name: "Ivory Lace", code: "SW 7013", hex: "#ECE5D8" },
    { name: "Ice Cube", code: "SW 6252", hex: "#E3E4E1" },
    { name: "Pearly White", code: "SW 7009", hex: "#E8E3D9" },
    { name: "Spare White", code: "SW 6203", hex: "#E4E4DD" },
    { name: "Panda White", code: "SW 6147", hex: "#EAE2D4" },
    { name: "Casa Blanca", code: "SW 7571", hex: "#EDE1CE" },
    { name: "Steamed Milk", code: "SW 7554", hex: "#ECE1D1" },
    { name: "White Heron", code: "SW 7627", hex: "#E7E1D7" },
    { name: "Origami White", code: "SW 7636", hex: "#E5E2DA" },
    { name: "Zurich White", code: "SW 7626", hex: "#E6E1D9" },
    { name: "Heron Plume", code: "SW 6070", hex: "#E5E1D8" },
    { name: "Shoji White", code: "SW 7042", hex: "#E6DFD3" },
    { name: "Aged White", code: "SW 9180", hex: "#E8DECD" },
    { name: "White Duck", code: "SW 7010", hex: "#E5DFD2" },
    { name: "Moderate White", code: "SW 6140", hex: "#E9DECF" },
    { name: "Incredible White", code: "SW 7028", hex: "#E3DED7" },
    { name: "Eider White", code: "SW 7014", hex: "#E2DED8" },
    { name: "Aesthetic White", code: "SW 7035", hex: "#E3DDD3" },
    { name: "Site White", code: "SW 7070", hex: "#DCDEDC" },
    { name: "Natural Choice", code: "SW 7011", hex: "#E3DED0" },
    { name: "Pacer White", code: "SW 6098", hex: "#E5DDD0" },
    { name: "Oyster White", code: "SW 7637", hex: "#E2DDD0" },
    { name: "Antique White", code: "SW 6119", hex: "#E8DCC6" },
    { name: "Divine White", code: "SW 6105", hex: "#E6DCCD" },
    { name: "Fleur de Sel", code: "SW 7666", hex: "#DCDDD8" },
    { name: "Neutral Ground", code: "SW 7568", hex: "#E2DACA" },
    { name: "City Loft", code: "SW 7631", hex: "#DFDAD1" },
    { name: "Egret White", code: "SW 7570", hex: "#DFD9CF" },
    { name: "First Star", code: "SW 7646", hex: "#DAD9D4" },
    { name: "Windfresh White", code: "SW 7628", hex: "#DED8CF" },
    { name: "Drift of Mist", code: "SW 9166", hex: "#DCD8D0" },
    { name: "Gossamer Veil", code: "SW 9165", hex: "#D3CEC4" }
  ],
  "Historic": [
    { name: "Classical White", code: "SW 2829", hex: "#ECE1CB" },
    { name: "Classical Yellow", code: "SW 2865", hex: "#F8D492" },
    { name: "Caen Stone", code: "SW 0028", hex: "#ECD0B1" },
    { name: "Aristocrat Peach", code: "SW 0027", hex: "#ECCEB9" },
    { name: "Acanthus", code: "SW 0029", hex: "#CDCDB4" },
    { name: "Colonial Yellow", code: "SW 0030", hex: "#EFC488" },
    { name: "Rachel Pink", code: "SW 0026", hex: "#E8B9AE" },
    { name: "Classical Gold", code: "SW 2831", hex: "#EBB875" },
    { name: "Colonial Revival Tan", code: "SW 2828", hex: "#D3B699" },
    { name: "Colonial Revival Gray", code: "SW 2832", hex: "#B4B9B9" },
    { name: "Dutch Tile Blue", code: "SW 0031", hex: "#9AABAB" },
    { name: "Rosedust", code: "SW 0025", hex: "#CC8D84" },
    { name: "Colonial Revival Green", code: "SW 2826", hex: "#A39B7E" },
    { name: "Colonial Revival Stone", code: "SW 2827", hex: "#A7947C" },
    { name: "Needlepoint Navy", code: "SW 0032", hex: "#546670" }
  ]
};
